var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCityOfLondonLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 404 548",
    width: 404,
    height: 548,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "City_of_London_logo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #000000 } \n\t\t.s2 { fill: #d8d4d1 } \n\t\t.s3 { fill: #383737 } \n\t\t.s4 { fill: #8c8b8b } \n\t\t.s5 { fill: #d50100 } \n\t\t.s6 { fill: #ec712a } \n\t\t.s7 { fill: none } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path224",
    className: "s0",
    d: "m137 143.2v62.5c0 2.7-0.1 15.7 0.6 21.1 7.8 57.8 64.4 78.4 64.4 78.4 0 0 56.6-20.6 64.3-78.4 0.7-5.4 0.7-18.4 0.6-21.1v-62.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path705",
    className: "s1",
    d: "m245.1 344.2c10 0.2 16.8-2.9 20.1-9.4-0.1 1.9-1.9 4.3-2.8 6.2q-0.2 0-0.3 0c-0.8 1.7-2.4 2.6-3.6 3.9-2.4 1.5-5.3 2.5-8.9 2.9q-46.5 0-93.1 0c-3.8-0.4-6.7-1.8-9.3-3.4q0-0.1 0-0.2c-1.6-1.1-2.6-2.8-3.9-4.1-0.7-1.7-1.6-3.1-2.1-4.8 0-0.2 0-0.3 0.2-0.3 3.3 6.6 10.3 9.4 20.4 9.2q41.6 0 83.3 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path569",
    fillRule: "evenodd",
    className: "s1",
    d: "m278.9 149c3.2 1.8 5.9 6.9 9.9 6.8 1.3-0.1 3.6-2.1 5.2-3.2 4.8-3.1 10.8-6.8 15.6-8.8-10.8 7-21.6 14-24.4 29-1.4 0.7-2.5 1.7-4.1 2.2-0.1-0.4 0.3-1.3-0.3-1.2q0-1.5 0-2.9c-0.2-3.5 2.9-4.7 2.9-7.5 0-3.6-6.3-7.7-7.9-10.3-0.6-0.8-2-3.4-3.1-2.1-1.4 2.1-3 4.2-6 4.8-0.2-0.4 1.6-1.9-0.3-2.2 0.2-2.3 1.6-3.1 1.2-5-0.4-2.7-4.4-3.5-7.4-3.9-1.3-0.4-4.2-0.4-5.5 0-2.3 0.1-2.7 2.1-3.4 3.9-0.6 0.7-2.5 0.1-2.1 1.9-1.4-1.1-1.8-3.8-1-5.8-0.2-0.5-1.3-0.1-1.9-0.2-0.9 0.7-0.7 2.4-1 3.6-0.4 1.1-2.5 0.5-2.6 1.9-0.9-0.6-0.7-2.2-1.2-3.1q0-1.2 0-2.4c-9.1 0.3-19.4-0.7-27.6 0.5-2.5 1.7-6.4 1.6-8.7-0.3-1.1 2.6-2.8 4.7-4.8 6.5-1 0.1-1.4 0.8-2.4 1-1.3 0.4-3.6 0.3-5 0q-0.2 0-0.5 0c-0.5-0.5-1.2-0.7-1.9-1-0.8-0.7-1.5-1.5-2.4-2.2-0.4-1.3-1.2-2.3-1-4.3-4.2-0.4-12.1-0.2-18.4-0.2-2.5 0-7.7-1.1-6.3 2.1 0 1.5-0.6 2.5-0.9 3.6-0.2-1.4-2-1.1-2.7-1.9-0.4-0.9-0.3-2.3-0.7-3.3 0-0.8-2.1-0.7-2.4-0.3 0.7-0.1-0.2 1.3 0.5 1.2 0.2 2.3-0.5 3.5-1.2 4.8 0-1.6-1.4-1.6-2.4-2.1-0.5-1.9-1.1-3.6-3.1-3.9-1.4-0.4-4.4-0.4-5.8 0-3.3 0.5-7 1.2-7.4 4.1-0.2 1.4 1 2.4 1.2 3.8 0.1 1.4-1.3 2.4-0.3 3.2-3-0.8-4.8-2.8-6-5.3q-0.2 0-0.5 0-0.8 0.5-1.4 1.4-1.3 1.1-2.4 2.4c-1 2.5-6.6 5.6-6.7 8.9-0.1 2.9 3.4 4.2 2.9 7.9q0 1.2 0 2.4c0 0.6 0 1.2-0.3 1.5-1.5-0.6-2.8-1.6-4.1-2.4-0.7-7.6-4.7-11.8-8.4-16.4q-1.6-1.9-3.6-3.6c-3.4-3-7.1-5.9-11.5-8.1 4.3 1.4 10 4.9 14.7 7.9 1.5 1 3.2 2.9 4.5 3.1 4.2 0.8 6.9-3.9 9.9-5.7q3.6-3.4 6.9-7c0.8-0.6 1.3-1.4 2-2.2 4.4-2 10-2.9 16-3.3q1.2 0 2.4 0c4.9 0.1 8.1 2 10.1 5 8 0.4 17.7 0.4 25.7 0 1.2-4.9 4-8.3 6.9-11.5 9.6-1.5 18.2-3.9 23.1-10.1 1.3 1.6 1.4 4.2 3.1 5.3-5.6 2.4-10 6-13.4 10.6 6.9-3.5 21.9-13.1 26.4-0.8q0 1.2 0 2.4c-0.8 1.4-1.4 3-2.9 3.6-0.3 0.1-1.2 0.9-0.3 0.8 3.9-0.3 9 0.6 12-0.5q0-0.1 0-0.3c1.2-0.8 2.1-1.9 3.2-2.8 2-0.9 4-1.7 6.9-1.7q1.2 0 2.4 0c5.7 0.3 10.7 1.3 15.1 2.9 0.2 0.3 0.4 0.5 0.8 0.4q1.3 1.6 2.8 2.9c0.1 0.5 0.5 0.7 0.8 1q2.1 2.4 4.5 4.5zm-47.7-8.6c3.8-8.3-8-5.9-9.9-2.2q-2.1 1.8-3.8 3.9c0 0.1-0.3 0.5-0.3 0.5 1.5 0.4 9.7 0.7 12 0 1.2-0.4 1.6-1.9 2-2.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path5",
    className: "s1",
    d: "m189.6 73.2c-2.3-2-6.4-3.2-6.7-7-0.2-3 3.3-6.6 5.1-8.6 14.6-16.4 30.2-34.9 37.9-57.1-6 21.4-17.1 40.5-30.3 56.6-2.4 3-6.2 6.2-4 9.9q1 1.3 2.4 2.4c5.5 1.7 7.5 12.9 3.1 17.5q-0.4 0-0.7 0c-0.8 0.1-2.1-0.3-2.4 0.2-1 0.1-1.6-0.2-2.2-0.5 0.1-2.7 2.5-7.8 0.2-10.8q-0.9-1.5-2.4-2.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path7",
    className: "s1",
    d: "m222.3 23.5c0.5-1.9 0.5-4.5 1.4-6 0.4 9.6 3.1 16.9 6.3 23.8-4.5-3.1-6.7-8.6-7.7-15.1q0-1.4 0-2.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path9",
    className: "s2",
    d: "m222.3 23.5q0 1.3 0 2.7c-0.4-0.4-0.4-2.3 0-2.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path11",
    className: "s1",
    d: "m217.2 49c-0.6 5.5-1.2 11.2-2.4 16.3 2.6 1.3 5.9 2.1 8.7 3.3 2.7 1.3 5.6 2.6 6.9 4.6-5-1.8-10.2-3.5-16-4.6-2.3 6.1-4.1 12.7-7 18-1.2 0.7-4.1 0.8-5-0.2 3-5.6 5.6-11.8 7.4-18.7-2.6-1.7-10.7 0.2-11-2.9-0.6-4.4 9.9-1 12-0.5 2.9-8.4 4.8-17.9 5.7-28.3 1.4 0.3 0.5 2.9 0.7 4.3q0 2.1 0 4.1 0 2.3 0 4.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path13",
    className: "s3",
    d: "m217.2 40.3c0.6 0.9 0.1 2.8 0.3 4.1q-0.1 0-0.3 0 0-2 0-4.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path15",
    className: "s4",
    d: "m232.4 44.6c0.5-0.4 2.7-0.4 3.3 0q-1.7 0-3.3 0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path17",
    className: "s1",
    d: "m235.7 44.6c-0.9 0.7-5.6 1.4-8.4 2.2-3 0.9-5 3-7.2 2.4 2.1-3.5 7.4-3.8 12.3-4.6q1.6 0 3.3 0z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path19",
    className: "s1",
    d: "m223.5 60c0.7-3.9 1.6-7.7 4.5-9.4-1.1 3.5-2.6 6.7-2.6 11.3-0.7 0.9 0.2 3.4-0.5 4.3-0.7 0.3-0.5-0.6-0.9-0.7-0.2-1-0.2-2.3-0.5-3.1q0-1.2 0-2.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path21",
    className: "s1",
    d: "m293.3 53.3c1.9-0.1 3.4-0.6 4.3-1.7 0 1.8-2.2 3.6-3.1 5.3-0.7 0.7-1.8 1.2-2.4 2.1-2.6 1.7-6.2 3.4-10.3 2.2-0.7 3.9-2.5 6.8-6 7.9 0.7-2.8 2.2-7.8-1.2-9.6-3.6-1.9-8.7-0.1-11.5 1.9-0.6-0.7 1-1.2 0.9-2.1 0.5-0.3 1-0.5 1-1.2 1.3-1.3 2.8-2.3 4.1-3.6 2.1-1.1 4.3-2 6.9-2.4q1.4 0 2.7 0c2.7 0.5 5.5 1 8.6 1.2 1.5 0.4 4.6 0.4 6 0z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path23",
    className: "s1",
    d: "m108.3 55.2q-0.9-1.6-1.9-3.1c1.1-0.1 2.5 1.4 4.5 1.2 1.5 0.4 4.6 0.4 6 0 3.2-0.2 5.9-0.7 8.7-1.2q1.3 0 2.6 0c6.3 1.1 10.2 4.5 13 9.1-3.3-2.3-12.4-4.2-13.7 1-0.6 2.1 0.3 4.6 0.9 6.7-3.8-0.7-5.3-3.8-6-7.7-3 1-7.7-0.1-10-1.9-0.2-0.4-0.4-0.8-1-0.7q-1-1.4-2.4-2.4c0-0.6-0.4-0.8-0.7-1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path25",
    className: "s2",
    d: "m125.6 52.1c0.3-0.4 2.3-0.4 2.6 0q-1.3 0-2.6 0z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path29",
    className: "s2",
    d: "m223.5 60q0 1.2 0 2.4c-0.4-0.3-0.4-2.1 0-2.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path31",
    className: "s1",
    d: "m349.7 84.7c0-6.3-1.3-11.3-1.9-17 5.1 12.9 8.8 27.2 17.8 36.2-4.1 8.5-8.7 16.3-12.3 25.2-0.2 0.1-0.1 0.5-0.5 0.5 0.7 0.5 1.5-1 2-1.4 13.3-14.6 24.6-31.2 34.5-49.5 1.4-2.5 2.4-5.4 4.6-7.4-5.2 15.7-14.6 31.3-24.3 45.1-7.2 10.3-15.1 19.4-23.5 29-2.3 2.8-7.4 8.5-5.7 12 2 4.4 9.3 1.7 8.6 8.4-0.5 4.6-6.2 8.9-9.8 11.6-2.3 1.6-4.9 4-7.7 4.8-2.2 0.6-4.7 0.1-4.8-2-0.2-2.2 5-4.9 6.9-6.2 2.3-1.6 6.8-3.8 6.8-6.2-0.1-3.4-10.7-4.6-10.8-9.9-5.1 6.2-11.5 21.6-5.1 30.7q2.2 2.5 4.6 4.6c6 8.2 18-3.4 26.1 1.2-6 1-10.9 3.1-14.8 6.2 0.6 1 1.6 1.4 2.4 2.2q0.1 0 0.2 0 1.1 1.4 2.4 2.4c1.2 0.7 1.6 2.2 2.9 2.9 3.4 3.9 5.8 9.5 7.4 16.1 1.6 6.3 3.2 13.2 7.2 16.3 3 2.3 11.6 3.1 12.5-1.9 0.4-2-0.3-4.5-1-6-2.1-5.3-6.9-10.8-7.2-17.3q0-1.7 0-3.4 1.6-7.3 8.9-8.9 1.3 0 2.7 0c8.8 0.9 10.4 15.4 1.9 17.8-1.8-0.8-2.6-2.5-3.4-4.3 2.4-1 4-2.4 3.4-5.3-0.8-3.6-7.1-3.6-7.2 0.7-0.4 1-0.4 3.6 0 4.6 0.3 2.4 1.7 3.9 2.9 5.5q1.1 1.5 2.6 2.6c0.3 0.7 0.6 1.2 1.2 1.5 8.3 9.1 4.1 26-9.8 26.1q-1.5 0-2.9 0c-7.5-1-12.9-4-17.1-8.4-0.9-14.7-4.1-27.4-12.4-34.8 0 4 1.9 7.4 3.3 10.8 2.8 6.8 4.3 14.8 5.8 23.6 0.7 4.2 0.8 11.3 2.9 14.1 1.1 1.5 3.5 2.7 5.5 3.6 2.4 1.1 5 2 5.3 3.6 0.2 1.5-1.5 4.3-2.2 6.3-1.7 4.5-2.7 8.1-3.6 13.2-0.4 2.4-1.3 5.8-0.7 7.6 0.6 2.3 4.5 2.5 4.8 5.1-8 0.4-13.4-6-20.2-6-2.1 0-2.8 1-4.8 0-0.8 0.1-1.1 0.8-1.2 1.7-1.4-1.4-0.3-3.6 0.3-5.1-2.7 0-3.2 1.2-5.1-0.2-1 0.2-1 1.3-1.4 2.2-2.1-3.2 1.1-6.4 4.1-6.8q1.3 0 2.6 0c4.5 1 7.3 3.6 12 4.3 2.5-5.3 4.6-11.1 7-16.5-3.6-2.6-7.7-4.7-11.3-7.2-1-1.2-2.5-1.9-3.6-2.9-1.1-0.7-1.8-1.8-3.1-2.4q-1.2-1.5-2.7-2.6c-0.5-0.2-0.6-0.8-1.2-1-5.2-6.5-11.2-11.9-11.3-21.6 0-7.4 7.1-10.8 5.8-19.7-0.4-2.6-1.9-4.4-3.8-6q-1.8-2-3.9-3.8c-3.5-4.4-7-8.8-9.8-13.9 0.7-2.2 1.9-3.9 2.4-6.3-1.1-0.1-1.3 0.7-1.9 1-0.9 0.5-1.8 0.9-2.4 1.7-1.2 0.3-1.8 1.2-2.9 1.6-2.2-0.4-3.7-1.4-6.3-1.4-1-0.4-3.7-0.4-4.8 0-1 0-1.7 0.2-2.4 0.5 2.4 6 6.3 10.5 10.1 15.1q2.3 2.6 4.8 4.8c4.2 4 9.5 7 14.9 9.8-3.7 0.5-8.4 0.6-13.2 1-5 0.4-13.4-0.3-14.2 3.4-0.6 3.1 2.3 6.3 3.6 8.1 2 2.6 3.8 4.2 5.6 6.3q1.4 1.7 3.1 3.1c0.1 0.3 0.4 0.4 0.5 0.7q4.4 4.7 9.1 9.1c0 0.4 0.2 0.6 0.5 0.7 0.5 1.2 1.2 2.2 0.9 4.1-3.5 3.5-9.2 4.9-12.5 8.7q-1.4 1.1-2.6 2.6c-0.8 0.8-3.5 2.4-1.7 3.6 1.4 1 2.5 2.3 3.1 4.1-1.4 0.4-2.7-1-4.3-1.7-1.5-0.7-3.2-1.2-5-1.9-4.3-1.8-9.3-5.4-14.4-3.1-1.1 0.2-1.4-0.4-2.2-0.5-1-0.1-1.1 1.9-1.7 1.4-1-2 0.9-3.1 1.2-4.5-2.7-1.1-3.4 2.3-5.7 0.4-1.1 0.3-1.4 1.2-1.7 2.2-2-3.9 2.1-6.9 5.8-7.4q1.3 0 2.6 0c3.5 0.5 7.5 4.1 11.5 4.3 3.9 0.2 13.5-3.6 15.1-7.5 1.6-3.6-0.4-7.4-2.8-10.3q-3.7-4-7.7-7.7c-4.1-4.1-12.2-17-3.9-21.8 2.6-1.4 5.7-1.3 9.4-1.9q1.8 0 3.6 0 0-0.3 0-0.5-1.4-1.7-3.1-3.1c-5.2-6.2-9.7-13.1-13.9-20.2-4.8 2.1-9.8 3.9-13.7 6.7 3.1 1.3 6.5 2.2 7.9 5.1-1.2-0.5-1.7 0.4-3.1 0.9-9.9-4.8-11.8 14.4-2.2 13 1 0.5 0.4 2.5 2.4 1.9-0.8 1.7-3 1.8-5.3 1.5-0.5 3.5 4.2 1.7 4.6 4.3 0 0.3 0.4 0.2 0.7 0.2-0.1 0.7-1 0.6-1.2 1.2-1.9 0.8-4.5 0.4-6.4-0.2-0.1-0.3-0.4-0.3-0.8-0.3-0.6-0.4-1.2-1-2.1-1.2q-3.4-3.4-4.3-9.3 0-2.8 0-5.5 0-0.8 0-1.5c0.9-4.6 1.9-9.3 4-12.7 0.8-0.6 1.8-1.1 2.4-1.9 15.4-10.5 34.4-24.6 50.7-36.3 3.3-2.3 11-5.4 8.1-11.7-0.5-1.3-1.2-1.8-2.8-2.4 1.4-0.9 3.5-0.2 5.2 0 0.9-1.9 1.7-3.8 2.7-5.5q1.8-2.1 3.8-3.9c0.9-0.4 1.8-0.7 2.4-1.4-4.7-1.3-6.9-5.1-9.3-8.7-1 3.5 0.8 7.5 1.4 9.4-1.2 0.6-2 1.7-2.9 2.6-0.6 1.1-1.4 2-1.9 3.2-8.9 0-15.3 2.6-22.8 4-1.1-0.1-3.8 0.5-2.4-0.7 0.6-1 1-2.3 1-4.1-1.4 0.4-2.6 0.9-3.9 1.2-2 0.2-3.3 0.1-1.7-1.2 1-1.3 1.4-3.3 1.7-5.2-2.7 0.1-6.2 0.3-8.4-1.2-0.2 0.3 0.7 1.5 0.7 2.4-3.7-1.3-6.7-3.4-7.2-8 0.5-0.9 1.3 1.6 2.7 1.2 0.7 0.4 3.1 0.4 3.8 0 0.7 0.2 0.6-0.3 1.2-0.2-0.3 1.3-1.5 1.7-1.9 2.9 2.1 2.3 6.6 2.1 9.8 0.9q1.2 0 2.4 0c3 0.4 5.2 1.4 7.2 2.7 3.6-0.3 7.5 1.3 10.4 0.2 1.8-4.5-7-4.4-11.1-5-8.2-1.3-16.2-1.1-16.3-9.6q0-0.1 0-0.3c-1.2 0.2-3-0.3-3.8 0.3-1.9-0.6 4.8-1.5 6.4-1.7q3.3 0 6.5 0c3.9 0.6 7.8 1 10.6 2.6-0.3 0.7-0.5 2.1 0 2.7 2.9 2.3 6.9-1.2 9.3-2.4-1-1.5-4-2.1-6.2-2.7-2.5-0.5-5.3-0.3-6.7-2.1 0.3-0.6 0.4-1.5 1.4-1.5 0.6-0.4 1.9-0.1 2.9-0.2 4.2 0.7 8.4 1.4 12 2.6-0.9-6 4.1-7.7 4.1-13.6 1 0.6 1.3 2 1.2 3.8 1.9-1.3 4.6-5.1 4-8.9 0.9-0.4 1.6 1.2 2.2 2.2 1.3 2 2.2 5 3.6 7.2-0.7 1.3-1 3.8 0 5q0.5 0.8 1.2 1.2c-0.1 0.5-0.5 0.8-0.7 1.2-0.6 1-0.9 1.5-1 2.4 0 1.2 1.2 2.6 1.2 2.9-0.1 1.5-2.5 1.6-2.1 3.6-0.7 1.4 1.5 2 2.1 2.9 0 0.7 0.6 0.9 1 1.2 4.8 7.9-2.8 18.8-5.3 25.7 9.7-11 15-26.4 16.3-45.9 0.6-0.9 0.1-2.8 0.3-4.1 0.4-3 0.4-7.7 0-10.8-0.2-1.3 0.3-3.3-0.3-4.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "path33",
    className: "s1",
    d: "m220.8 76.6c-2.9 2.9-4.4 7.4-7.2 10.5 0.1-3.7 3.3-9.6 6.3-12 0.7-0.5 3.2-2.1 3.6-1.2q-1.5 1.2-2.7 2.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "path37",
    className: "s1",
    d: "m114.5 77.5c2.6-2.1 7.5-3.9 11.8-2.1-4.4 1.4-8.7 4.1-7.7 10 0.4 2.3 2.4 3.6 2.9 5.3-3.6 1-5.5-1.2-7.2-2.9-2.8 3.9-8.9 6.6-14.4 3.2 5.6-1.7 8.3-6.2 11.5-10.4q1.7-1.4 3.1-3.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path39",
    className: "s1",
    d: "m280.6 74.6q1.4 0 2.9 0c6.7 1.6 9.5 7 13.4 11.3q1.2 1.5 2.7 2.7c1.3 0.9 2.5 2.1 4.8 2.1-3.4 2.7-10.6 2.3-12.8-1.2-0.5-0.5-0.7-1.3-1.4-1.7-1.3 0.5-1.9 1.7-2.9 2.4-1.4 0.7-3.4 1-5 0.3 6.1-4.5 3-14.7-4.6-14.9 0.6-0.7 2.1-0.5 2.9-1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "path41",
    className: "s2",
    d: "m134 78c0.6-0.4 2.9-0.4 3.6 0q-1.8 0-3.6 0z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "path45",
    className: "s3",
    d: "m194 87.1c0.3-0.5 1.6-0.1 2.4-0.2-0.4 0.5-1.7 0.1-2.4 0.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "path47",
    className: "s1",
    d: "m387.9 100.6c0.8-4.3 1.8-9.6 4.3-11.3-0.1 2.3-0.9 3.9-0.7 6.5-0.6 0.8-0.1 2.8-0.3 4-0.4 0.8-0.4 3.2 0 3.9 0.2 1.3-0.3 3.2 0.3 4.1-0.2 4.8 1.8 8.7 1.7 12.7-3.5-3-4.3-8.6-5.3-13.9q0-3 0-6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "path49",
    className: "s1",
    d: "m12.8 97.7c0-3.2-0.6-5.7-1-8.4 1.7 1 2.7 3.6 3.4 6 1.5 5.3 1.4 12.4-0.3 18-0.8 2.9-2.1 6-4.1 7.2 0.3-4.4 2.1-9.1 2-14.7 0.4-2.1 0.4-6 0-8.1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "path51",
    className: "s2",
    d: "m193.5 90.5c0.4-0.4 2.4-0.4 2.9 0q-1.5 0-2.9 0z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "path53",
    className: "s2",
    d: "m203.8 90.5c0.4-0.4 2.5-0.4 2.9 0q-1.5 0-2.9 0z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "path55",
    className: "s2",
    d: "m213.9 90.5c0.4-0.4 2.4-0.4 2.9 0q-1.5 0-2.9 0z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "path57",
    className: "s1",
    d: "m193.5 90.5q1.4 0 2.9 0c1.5 0.8 3.2 3.7 2.6 5.3q-1.6 0-3.1 0c-1.5-0.9-3.3-3.7-2.4-5.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "path59",
    className: "s1",
    d: "m203.8 90.5q1.4 0 2.9 0c1.7 0.7 2.1 2.7 2.9 4.3q0 0.4 0 0.7c-0.8 0.5-2.3 0.2-3.4 0.3-1.5-0.9-3.3-3.6-2.4-5.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "path61",
    className: "s1",
    d: "m213.9 90.5q1.4 0 2.9 0c3.1 0.7 2.4 5.3-0.3 5.3-2-0.1-2.6-3-3.1-5.1q0.4 0.1 0.5-0.2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "path63",
    className: "s1",
    d: "m186.8 91.2c1.4 0.6 2.1 3 2.1 4.3-2.7 0.1-3.3-2.5-2.1-4.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "path67",
    className: "s4",
    d: "m190.8 99.4c8-0.4 17.6-0.4 25.5 0q-12.7 0-25.5 0z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "path69",
    fillRule: "evenodd",
    className: "s1",
    d: "m186.3 124.6c-0.8-1.6-3.6-5-4.1-9.2-0.7-5.9 0.6-14.1 6.5-13.6 0.6-0.5 0.3-1.9 0.9-2.4q0.6 0 1.2 0 12.8 0 25.5 0c0.1 0.9-0.2 2.3 0.2 2.8q0 1.4 0 2.7 0 2.6 0 5.3c0.2 7.8-4.1 11-9.1 13.6-0.9 0.5-1.9 0.8-2.6 1.5-4.6 1.8-11.5 6.1-16.1 1.7q-1.1-1.4-2.4-2.4zm2.9-15.2c0.3-1.1 1.1-4.1-0.3-4.8-2.9 0.4-3 3.6-3.3 6.5-0.4 0.7-0.4 3.1 0 3.9 0.5 3.8 2.4 8.8 6.2 9.1 0.2-4.1-2.6-7.2-2.6-11.8q0-1.4 0-2.9zm6.4-0.2c0.2-1 1.3-3.9-0.2-4.3-2.3-0.6-2.9 2.5-3.1 4.8-0.4 1.1-0.4 3.9 0 5 0.9 3.2 2 7.6 5.7 7.2 0.2-3.4-2.2-6.2-2.4-10.1q0-1.3 0-2.6zm8.2 10.6c0.8-2.7-1.4-5.5-1.7-8.9-0.2-2.6 0.7-4.1 0.3-6-6.3-0.5-4.2 15.2 1.4 14.9z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "path71",
    className: "s1",
    d: "m159.4 109.9c6.4-4.7 14-8.3 23.3-10.3-1.4 1.3-3.1 2.3-4.6 3.6-2.3 1.8-4.3 3.8-6.2 6-3.6 4.4-6.8 9.1-6.7 17-1.5-1.9-2.6-4.2-2.7-7.4q0-1.2 0-2.4 0-0.6 0-1.2c-3.5 0.6-6 2.3-8.4 4.1-1.1 0.4-2.4 3.1-3.1 2.4 0.8-3.3 2.7-5.5 4.3-7.9q1.5-1.2 2.7-2.7c0.8-0.1 1-0.7 1.4-1.2z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "path73",
    className: "s1",
    d: "m228.8 105.4c-2.2-2-4.6-3.8-7-5.6 8.9 1.4 17.1 5.6 23.5 10.4 1.4 1.5 2.9 2.9 4.3 4.3 1.5 2.3 3.3 4.4 3.9 7.7-1-0.6-1.5-1.6-2.4-2.2-2.3-2-4.9-3.7-8.4-4.6q-0.1-0.2-0.5-0.2c-0.6 0.9-0.1 2.8-0.2 4.1-0.5 2.6-1.2 4.9-2.4 6.7-0.7-7.7-3.6-13.2-7.7-17.5q-1.4-1.7-3.1-3.1z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "path75",
    className: "s3",
    d: "m391.2 99.8q0 2 0 3.9c-0.4-0.7-0.4-3.1 0-3.9z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "path79",
    className: "s4",
    d: "m216.5 104.9q0.1 0 0.3 0c-0.2 1.7 0.3 4-0.3 5.3q0-2.7 0-5.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "path85",
    className: "s1",
    d: "m354.5 173c3.8-4.2 7.2-8.8 9.6-14.4-3.2-2.1-12.5 0.7-13.2-3.3-0.4-2.3 2-3.5 3.9-3.6 3.9-0.3 8.1 2 11.7 1.9 6-11.9 9.8-26.1 11.5-42.2 0.9 0.1 0.4 1.7 0.5 2.6q0 3 0 6c-0.5 13.5-3.5 24.7-6.9 35.3 5.6 2.2 11.3 4.3 16.8 6.9 1.7 0.8 3.7 1.7 4.8 3.2-7.6-2.1-15-4.4-23.3-5.8-3.2 6.6-6.6 13-11.1 18.5q-2.7 2.5-5.2 5.3c-3.7 1.8-8 7.2-13.2 7.2-1.3-0.1-3.6-0.9-3.9-2.2-0.6-3.3 4.9-5 7-6.2 3-1.9 5.2-3.6 7.4-5.6q2-1.6 3.6-3.6z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "path87",
    className: "s1",
    d: "m25.5 112.1c0.2 0 0.2-0.3 0.2-0.5 1.5 3.7 1.3 7.7 1.9 11.5 1.9 11 5.7 21.5 9.9 30.5 4.4-0.3 15.9-4.5 15.8 1.2 0 4.4-9.8 2.1-13.4 3.6 4 8.7 10.8 17.7 19.9 23.3 2.4 1.5 8.3 3.5 7.9 6.5-0.1 1.2-2.2 2.3-3.8 2.4-5.2 0.1-9-4.9-12.5-6.5-0.4-0.7-0.9-1.2-1.7-1.5q-1.6-1.9-3.6-3.6-0.4-1.1-1.4-1.6c-3.9-5.4-7.7-11-10.1-17.8-8.6 1.2-16 3.7-23.8 5.8 0.1-1 1.3-0.9 1.7-1.5q1.9-0.6 3.4-1.7c5.4-2.5 10.9-4.9 16.8-6.9-3.5-9.7-6.1-20.1-7-32.4-0.1-1.7 0.3-4-0.2-5.3q0-0.5 0-1 0-2.2 0-4.5z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "path89",
    className: "s2",
    d: "m25.5 116.6c-0.4-0.8-0.4-4.5 0-4.5q0 2.3 0 4.5z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "path91",
    className: "s2",
    d: "m105.6 114c1.6-0.4 4.9-0.4 6.5 0q-3.2 0-6.5 0z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "path95",
    className: "s2",
    d: "m378.5 114c0.4 1.4 0.4 4.6 0 6q0-3 0-6z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "path97",
    className: "s4",
    d: "m162.5 118.8c-0.4-0.3-0.4-2.1 0-2.4q0 1.2 0 2.4z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "path99",
    className: "s4",
    d: "m2 123.6c0.8-0.4 3.2-0.4 4 0q-2 0-4 0z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "path101",
    className: "s4",
    d: "m398 123.6c0.8-0.4 3.4-0.4 4.3 0q-2.2 0-4.3 0z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "path103",
    className: "s1",
    d: "m6 123.6c3.6 0.1 7.4 0.8 10.4 1.9 2.6 1 6.2 2.3 6.2 5.3-1.8 0.4-3.3-1.2-4.8-1.9-4.6-2.4-10.6-3.4-16.3-4.8 0.1-0.2 0.2-0.4 0.5-0.5q2 0 4 0z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "path105",
    className: "s1",
    d: "m384 127.2c3.8-2 8.4-3.4 14-3.6q2.1 0 4.3 0 0.1 0 0.2 0c-1.4 1.5-3.6 1.3-5.5 1.7-3.6 0.8-7.5 1.9-10.8 3.6-1.5 0.7-3 2.3-4.8 1.9-0.3-0.8 0-0.5 0-1.4 0.8-0.8 1.9-1.4 2.6-2.2z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "path107",
    className: "s4",
    d: "m104.7 127.4c0.2-0.4 2.1-0.4 2.4 0q-1.2 0-2.4 0z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "path111",
    className: "s1",
    d: "m15.2 152.6c-0.2-8.8-2-15.9-4.1-22.8 5.1 2.5 7.5 14.2 6.9 22.6-0.1 2.4-0.6 6.6-2.4 7.2-0.7-1.8 0.3-5.2-0.4-7z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "path113",
    className: "s1",
    d: "m386 147.4c0.9-7.2 1.9-14.4 6.9-17.6-1.5 5.6-3.6 12.7-3.8 20.4-0.6 2.6-0.1 6.2-0.3 9.2-2.8 0.2-2-5.1-2.8-7.7q0-2.2 0-4.3z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "path117",
    className: "s4",
    d: "m149.3 137.3c0.3-0.4 2.2-0.4 2.4 0q-1.2 0-2.4 0z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "path119",
    className: "s4",
    d: "m252.5 137.3c0.3-0.4 2.2-0.4 2.4 0q-1.2 0-2.4 0z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "path121",
    className: "s2",
    d: "m386 147.4q0 2.1 0 4.3c-0.4-0.9-0.4-3.5 0-4.3z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "path123",
    className: "s5",
    d: "m163.5 159.6c-0.2-2.5 0.2-4.2 1.7-5 0 0.9 0.7 1.1 0.9 1.9 0.2 1-0.3 2.7 0.3 3.3q0 2.9 0 5.8c0.1 2.7-0.4 6.1 0.2 8.4q0 3.1 0 6.2c0.2 2.2-0.3 5 0.2 6.8q0 1 0 2.1c2.4 0.5 6.8 1.9 4.6 4.6-1.8-0.2-2.3-1.8-4.1-1.9-1.1 2.5-0.2 6.4-1.4 9.6-4.2 0.9-2.1-6.9-2.9-9.4-2.4-0.5-6.3-1.6-5-4.3 1.7-0.8 2.8 2.3 4.8 1.4 0.5-1.7 0-4.4 0.2-6.5 0.6-1.6 0.1-4.4 0.2-6.4q0-3.2 0-6.3c0.6-2.9 0.1-6.9 0.3-10.3z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "path125",
    className: "s1",
    d: "m137.1 188.6c-1.2-10.4-1.5-21.6-2.4-32.4 0.5 0.2 0.7 0.6 1.4 0.5 1.7 1.7 1 4.8 1 7.2 0 7.7 0 17 0 24.7z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "path127",
    className: "s1",
    d: "m268.1 156.7c0.5 0 0.8-0.1 1-0.5-0.3 10.3-1.2 22.1-2.2 32.4 0.2-10.4-0.3-21.6 0.3-31.6 0.3-0.1 0.8 0 0.9-0.3z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "path133",
    className: "s1",
    d: "m24 170.6c-1.7-1.7-3.8-3-5.5-4.8 5.4-0.1 8.5 4.2 12 6.8 0.4 1.1 1.4 1.6 2.2 2.4 2.7 3.8 5.7 7.4 7.2 12.4-0.2 0.1-0.4 0.2-0.5 0.5-1.1 0-0.8-1.2-1.7-1.4-2.2-4-5.3-7.1-8.1-10.3q-2.6-2.9-5.6-5.6z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "path137",
    className: "s1",
    d: "m377.3 169.2c2.6-1.4 4.4-3.4 8.2-3.6-0.2 1.4-2.8 2.3-3.9 3.6q-1.3 1-2.4 2.4c-1.4 1-2.5 2.2-3.6 3.6q-1.4 1.2-2.6 2.6c-1.4 1.8-2.9 3.3-4.3 5.1-1.3 1.6-2.2 3.9-4.1 5 0.2-5.7 4.6-9.3 7.2-13.4q2.2-1.9 4.1-4.1c0.8-0.1 1-0.7 1.4-1.2z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "path141",
    className: "s4",
    d: "m123.2 171.1c0.4 0.3 0.4 2.2 0 2.4q0-1.2 0-2.4z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "path147",
    className: "s1",
    d: "m364.8 193.7c0.2 1 1.1 1.1 1.2 2.1-3.4-2.9-7.6-5.2-12.4-6.7 1.8-3.2 6.2 0.7 8.4 1.7q1.2 1.6 2.8 2.9z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "path149",
    className: "s2",
    d: "m25.5 203c0.2-0.4 2.1-0.4 2.4 0q-1.2 0-2.4 0z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "path155",
    className: "s4",
    d: "m36.8 212.4c0.4 0.3 0.4 2.3 0 2.6q0-1.3 0-2.6z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "path161",
    className: "s2",
    d: "m128.4 256.6c0.3-0.4 2.2-0.4 2.4 0q-1.2 0-2.4 0z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "path165",
    className: "s1",
    d: "m133.7 280.6c-0.5-4.5-0.6-9.4-2.4-12.5 3.6-0.8 7.6-1.1 11.3-1.7-0.4 0.8-0.6 2-1 2.9-1.8-0.5-4.4-0.3-6 0.2 0.1 2.1 0.5 3.9 0.8 5.8 1.8-0.4 4.1-0.4 5.7-1 0.6 0.8-0.4 2-0.5 2.9-1.4-0.6-3.4 0-5 0 0.2 2.1 0.7 3.8 0.7 6 3-0.3 6-0.6 7.7-2.2 0.4 0.7-0.2 2.4-0.2 3.4-3.8 0.3-7.3 0.9-10.8 1.4-0.2-1.6 0.3-4-0.3-5.2z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "path167",
    className: "s1",
    d: "m124.8 269.3c1.1 6.5 3.6 11.6 5.6 17.3-3.1 1.8-6.3-2.1-8.7-3.6-2.4-1.6-4.5-3-6.5-3.9 0.7 3.5 2.4 8 4.1 11.3-1.3 0.1-2.1 0.7-3.3 1 0.1-2.7-1.1-5.2-2-7.7-1.2-3.5-1.4-7.6-4.8-8.7 0.8-0.8 2.4-0.9 3.6-1.4 4.6 2.7 8.7 5.9 13.2 8.6-1-4.3-2.3-8.3-4.3-11.7 1.1-0.3 2.2-0.7 3.1-1.2z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "path169",
    className: "s1",
    d: "m282.8 270.5c1.3 0.4 2.5 1 3.8 1.4 1.6 4.9 2.5 10.5 4.6 14.9 1.4-3.7 3.3-6.9 3.8-11.5 1.3 0.2 2.2 0.8 3.4 1.2-3.1 4.7-4.9 10.7-6.8 16.5-0.9-0.3-1.7-0.8-2.8-0.9-0.7-5.5-2.8-9.6-3.9-14.7-1.2 1.5-1.9 3.5-2.6 5.3-0.8 1.9-1.3 4-1.5 6.3-1-0.6-2.3-0.9-3.3-1.5 1.8-2.1 2.4-4.8 3.8-8.4 1.3-3.2 2.9-5.3 1.5-8.6z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "path171",
    className: "s1",
    d: "m103.5 277.7c2 6 4.6 11.4 7.7 16.3-1.5 0.4-2.4 1.3-3.9 1.7-1.6-6.3-4.5-11.3-7.4-16.3q1.9-0.7 3.6-1.7z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "path173",
    fillRule: "evenodd",
    className: "s1",
    d: "m307.5 281.8c8.1-0.4 14.1 9.5 8.4 15.8-5.2 5.7-18.4 2.4-17.1-7.9 0.6-4 3.8-7.7 8.7-7.9zm-5.5 10.8c0.7 4.9 7 7.1 10.5 4.5 4.1-3.1 2.4-10.6-0.9-12.2-1-0.5-2.5-0.7-4.1-0.5-3.7 0.5-6.3 3.1-5.5 8.2z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "path177",
    className: "s1",
    d: "m91.5 283.7q1.4-0.4 2.4-1.2c2.7 5.4 5.1 11.2 9.1 15.3-0.2 0.3-0.4 0.4-0.7 0.5-0.9 0.6-2.3 0.8-2.9 1.7q-0.2 0-0.5 0c-0.5-3.8-2.7-5.9-4.1-8.9-0.2-0.3-0.4-0.7-0.7-0.9-0.5 0.3-0.1 1.6-0.2 2.4-0.6 1-0.1 3.1-0.3 4.5q0 2.3 0 4.6c0.1 0.4-0.4 0.6 0 0.7-3.5-1.2-6.9-4.7-10.5-6.7 1.2 3.7 2.5 7.4 5 9.8q-1.5 1.1-3.3 1.7c-1.9-5.7-3.7-12.6-8-15.8 0.8-0.8 2.2-1 2.9-1.7 3.5 2.1 6.5 4.7 10.1 6.7 0.2 0.5 0.6 0.6 1.2 0.7 0.6-1.5 0.1-4.1 0.2-6q0-0.1 0-0.2c0.6-1 0.1-3 0.3-4.3q0-1.5 0-2.9z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "path179",
    className: "s2",
    d: "m330.8 282.7c0.3-0.4 2.3-0.4 2.6 0q-1.3 0-2.6 0z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "path185",
    className: "s2",
    d: "m257.1 289.9c0.7-0.4 3.1-0.4 3.8 0q-1.9 0-3.8 0z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "path187",
    className: "s1",
    d: "m143.8 289.9q2 0 4.1 0c3.8 0.5 7.4 0.8 11.5 1.7 2.7 0.6 8.3 2 8.2 4.8-0.1 1.8-4.4 4.3-6.3 5.5-4.8 3.2-9 5.5-11.7 9.6-7.2-0.7-13-6.9-9.6-14.4 0.8-1 1.7-1.9 2.4-3.1-1.3 0.2-3.2-0.3-4.1 0.2-25 3.2-44.4 18.6-65.1 27.9-7.1 3.2-15.3 6.6-23.5 7.2-11.6 0.8-17.7-4.3-18.2-15.4 2 7.9 6.4 13.6 17.3 13 8.8-0.5 16.9-4.5 24.7-8.2 14.9-7.1 28.3-15.2 43.9-21.8 8.3-3.5 17.4-6.3 26.4-7z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "path189",
    className: "s1",
    d: "m317.1 303.8c0.1-0.4 0.5-0.6 0.5-1.2 0.5 2.7 7.9 6.8 7.9 1.5 0-2.7-4-4.7-4.1-7.9-0.1-6.3 8.6-5.7 11.8-1.5-0.4 0.9-1 1.6-1.2 2.7-0.5-3.2-7.2-5.8-7.5-1.7-0.2 2.9 4.4 4.8 4.3 8.4-0.1 5.1-6.8 6-10.8 2.6-0.5-0.8-2.1-1.6-0.9-2.9z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "path191",
    fillRule: "evenodd",
    className: "s1",
    d: "m79 306.2c-1.1 4.8-6.3 9.9-12.5 8.2-9.1-2.4-9.5-17.1 1.5-18.5 3.2-0.4 4.6 0.6 7.2 1.7q1 1.4 2.4 2.4 0.7 1.9 1.4 3.8 0 1.2 0 2.4zm-3.4 2.2c3.3-9.3-10.3-13.7-12.9-6.2-1.9 5.4 2.5 9.9 7.2 9.6 3-0.2 5-1.4 5.7-3.4z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "path195",
    fillRule: "evenodd",
    className: "s1",
    d: "m53.8 319.2c-2.5 1.8-6.8 1.9-10.3 2.6 0.5-6.2-1.4-13.3-2.7-17.7 4.1-1.1 10.5-1.7 13.2 0.9 0.8 1 1.7 1.8 2.4 2.7 1.7 2.4 1.3 6.6-0.2 8.9-0.8 0.9-1.7 1.7-2.4 2.6zm-8.9-13.9c0.5 4.9 1.5 9.2 2.2 13.9 10.1 0.3 9-16.3-2.2-13.9z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "path207",
    className: "s1",
    d: "m218.4 333.8c-4.7-10.1 5.9-17.4 16.4-13.9q0 1.9 0 3.9c-5.8-4.5-15-2.4-14.2 5.7 0.5 4.9 4.8 7.4 10.6 6.7q0.1 0 0.2 0c0.4-1.4 0.4-4.5 0-6 0-0.5 0-1.1-0.2-1.4q0-0.1 0-0.2 2.2 0 4.5 0c0 0.5-0.4 0.7-0.2 1.4-0.6 2.2-0.1 5.4-0.3 7.9-3.9 1.2-10 1-13.2-0.7-1.2-1-2.5-2.1-3.6-3.4z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "path211",
    fillRule: "evenodd",
    className: "s1",
    d: "m154.6 321.8c0.1-1-0.2-1.7-0.5-2.4q2.9 0 5.8 0c6.3 0.2 9.2 3.7 10.8 8.4 0 1.1 0.1 2.2-0.3 2.9-1.2 4.3-3.9 7.1-8.8 7.7q-3.8 0-7.5 0c0.3-0.6 0.6-1.3 0.5-2.4 0.4-4.2 0.4-10 0-14.2zm3.8 14.4c6.9 0.6 10.3-5.1 8.2-10-1-2.5-4-4.6-8.2-4.6-0.4 4.3-0.4 10.3 0 14.6z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "path213",
    className: "s1",
    d: "m176.7 322.1c0.1-1.1-0.2-1.9-0.5-2.7q2.4 0 4.8 0c-0.2 1.1-0.6 2-0.5 3.4-0.4 3.5-0.4 8.7 0 12.2-0.1 1.5 0.3 2.4 0.5 3.4q-2.4 0-4.8 0c0.3-0.8 0.6-1.5 0.5-2.6 0.4-4 0.4-9.7 0-13.7z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "path215",
    fillRule: "evenodd",
    className: "s1",
    d: "m187.7 322.3c0.2-1.3-0.3-1.9-0.5-2.9q3.2 0 6.3 0c6.8-0.4 8.2 9.7 1.9 10.8 0.9 2.1 2.5 3.5 3.8 5.1q1.1 1.3 2.4 2.4c0 0.5 0.7 0.3 0.5 0.9-1.4 0.1-3 0.2-3.8-0.4q-1.8-2.1-3.9-3.9c0-0.2-0.2-0.2-0.2-0.5-0.8-0.8-1.4-1.9-2.4-2.6q-0.1 0-0.2 0c-0.4 0.8-0.4 3.3 0 4.1-0.2 1.3 0.2 2.1 0.4 3.1q-2.4 0-4.8 0c0.4-0.8 0.6-1.7 0.5-2.9 0.4-3.8 0.4-9.3 0-13.2zm3.9 6.5c6 0.9 6.2-8.1 0-7.2-0.4 1.8-0.4 5.4 0 7.2z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "path217",
    className: "s1",
    d: "m211.5 319.7c-0.1 0.5-0.4 0.9-0.3 1.7-0.4 4.4-0.4 10.6 0 15.1-0.1 0.8 0.2 1.1 0.3 1.7q0 0.1 0 0.2-2.4 0-4.8 0c0.2-0.6 0.6-1.2 0.5-2.2 0.4-4.3 0.4-10.3 0-14.6 0.1-0.8-0.2-1.1-0.3-1.7 0.5-0.9 3.7-0.5 4.6-0.2z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "path219",
    className: "s1",
    d: "m241.7 319.7c3.5-0.6 7.9-0.1 11.8-0.3-0.5 0.9-0.9 1.9-1.2 2.9-0.6-0.2-1.1-0.5-1.9-0.5-1.1-0.5-3.2 0-4.6-0.2q0 3.1 0 6.2c0.4 0 0.9 0.2 1-0.2 2-0.1 3.7 0.1 5.5 0.2-0.4 1-1 1.6-1.2 2.7-0.3-0.2-0.7-0.3-1.2-0.3-0.9-0.5-2.8 0-4.1-0.2q0 3 0 6c1.1 0.4 3.9 0.4 5 0 1.6 0.2 2.1-0.7 3.4-0.7q-0.5 1.3-0.7 2.9c-3.4 0.4-8.4 0.4-11.8 0 0-0.6 0.4-0.7 0.3-1.5 0.4-4.6 0.4-10.9 0-15.6 0.1-0.7-0.3-0.9-0.3-1.4z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "path239",
    className: "s1",
    d: "m138.5 367.4q2.3 0 4.6 0c4.1 0.4 7.6 1.4 11 2.4q0 5.2 0 10.4c-3.6-2.4-7.1-4.8-12.9-4.8-0.4-0.4-2.3-0.4-2.7 0-3.7 0-6 1.3-8.1 2.8q-1.7 1.4-3.2 3.2c-1.8 2.5-3.3 5.2-3.6 9.3-0.4 1.6-0.4 4.9 0 6.5 1.1 8.3 5.7 15.4 14.9 15.6 6.1 0.1 11.2-2.2 15.1-5.3 0.6-0.1 1.1-1.5 1.5-0.9q0 4.8 0 9.6c-0.5 0.3-1.3 0.4-1.7 0.9-3.5 1.6-7.3 3-12 3.4q-2.2 0-4.3 0c-5.8-0.6-10.1-2.6-13.9-5.1-0.3-0.6-0.9-0.9-1.5-1.2q-1-1.3-2.4-2.4c0-0.7-0.5-0.9-0.9-1.2-2.5-3.5-4.4-7.7-5.1-13.2q0-2.4 0-4.8c0.7-6.4 3-11.3 6-15.3q2.2-1.9 4.1-4.1c4.1-2.9 8.8-5.1 15.1-5.8z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "path241",
    className: "s1",
    d: "m169.2 368.6c4-0.5 8.9 0 13.2-0.2 0 0.3-0.3 0.3-0.2 0.7-0.7 2.8-1.5 5.4-1.4 8.9-0.4 10.3-0.4 22.3 0 32.6 0 3.5 0.7 6.4 1.6 8.9q0 0.3 0 0.5-6.6 0-13.2 0c0.1-0.2 0.3-0.2 0.3-0.5 0.6-2.7 1.4-5.1 1.4-8.4 0.4-10.7 0.4-23.1 0-33.8-0.1-3.4-0.7-6.2-1.7-8.7z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "path245",
    className: "s1",
    d: "m196.1 368.4c13.9 0.2 28.5-0.3 42 0.2-1.4 3.4-3.1 6.6-4.5 9.9-3.6-1.9-7.8-3.1-13.5-2.9-0.5 10.2-0.1 21.5-0.2 32.2 0 0.3-0.1 0.6 0.2 0.7 0.2 1.1-0.3 2.9 0.3 3.6 0 3 0.8 5.2 1.4 7.7q0 0.1 0 0.2c-4.2-0.2-9.1 0.3-13-0.2 0.6-2.5 1.4-4.7 1.5-7.7 0.5-0.8 0.1-2.7 0.2-3.9 0.6-10 0.1-21.2 0.3-31.6q0-0.4 0-0.8c-1.1-0.4-3.8-0.4-4.8 0-4.3 0-7 1.5-9.9 2.9q0-5.1 0-10.3z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "path247",
    className: "s1",
    d: "m248 371c-0.5-1.1-2.6-1.8-2.4-2.6q7.3 0 14.6 0 0 0.4 0 0.7c1.1 8.1 5.8 12.6 8.6 19 3.1-5.9 7.9-11.4 8.7-18.7q0-0.5 0-1c3.9 0.9 11.4-1.2 14.6 0 0.8 0.3 0.4 0.1-0.2 0.7q-1.4 1.1-2.4 2.4c-6.2 8.6-10.7 18.8-15.9 28.3 0.2 3.7-0.3 8 0.3 11.3 0 3.3 0.8 5.7 1.4 8.4 0 0.2 0.1 0.3 0.3 0.3-3.1 1.2-9.3-0.4-13.2 0.2 1.1-3.5 1.8-7.5 1.9-12-0.2-2.7 0.3-6.1-0.3-8.4-5.1-9.7-9.7-20-16-28.6z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "path257",
    fillRule: "evenodd",
    className: "s1",
    d: "m181.2 439c0.8-7 10.1-11.2 16.8-7q1.1 1.4 2.4 2.4c0.9 1.5 1.5 3.2 2 5q0 1.6 0 3.2c-1 11.4-20.4 11.6-21.2 0q0-1.8 0-3.6zm4.4 2.8c-0.5 5.7 7 8.6 10.8 5.1 3.9-3.6 1.7-11.8-2.4-13.2-4-1.3-8.3 1.1-8.4 5-0.4 0.5-0.4 2.6 0 3.1z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "path259",
    className: "s1",
    d: "m210 433c0.1-1.1-0.1-1.8-0.4-2.4q6.2 0 12.4 0 0.6 0 1.2 0c-0.4 1.4-1.2 2.4-1.6 3.8-1.2-0.7-2.6-1.1-4.6-1-0.5-0.5-2 0-2.9-0.2-0.4 1.4-0.4 4.6 0 6q3.3 0 6.5 0c-0.7 1.3-1.4 2.6-2.2 3.8-1.1-0.5-2.4-1-4.3-0.9-0.4 1-0.4 3.7 0 4.8-0.1 1.7 0.3 2.9 0.5 4.3q-2.4 0-4.8 0c-0.1-0.9 0.4-1.2 0.2-2.2 0.4-4.8 0.4-11.2 0-16z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "path277",
    fillRule: "evenodd",
    className: "s1",
    d: "m102.3 461.5q2.6 0 5.3 0c5.4 0.7 9.6 2.7 13.2 5.3 1.4 1.4 2.8 2.9 4.3 4.3 2.9 4.2 5.1 9.2 5.7 15.6q0 2.1 0 4.1c-0.6 6.4-3 11.1-6 15.1q-1.6 1.3-2.8 2.9c-0.7 0.3-1.2 0.6-1.5 1.2-17.5 12.9-43.5 1.2-42.9-20.6q0-1.4 0-2.7c1.5-15.1 10.3-22.9 24.7-25.2zm10.8 11.8c-9.6-7.6-25.6-1.1-24.7 12-0.4 0.5-0.4 2.8 0 3.3-1 13.8 15 23.7 25.6 15.4q1.4-1.1 2.4-2.4c1.7-2.3 3.1-4.7 3.4-8.4 0.4-1.6 0.4-4.9 0-6.5-0.3-4.8-2.1-8.1-4.3-11q-1.1-1.4-2.4-2.4z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "path279",
    fillRule: "evenodd",
    className: "s1",
    d: "m284.9 461.5q2.5 0 5.1 0c5.5 0.7 9.7 2.7 13.4 5.3q2 2.1 4.1 4.1c3.1 4.1 5.3 9.1 6 15.6q0 2.3 0 4.5c-0.7 6.3-3 11-6 14.9q-1.9 1.6-3.4 3.4c-7.1 7.2-26 8.3-33.8 0.9-1.4-1.4-2.8-2.9-4.3-4.3-3.1-4.4-5.6-9.3-5.8-16.5q0-1.2 0-2.4c0.2-6.6 2.5-11.1 5.3-15.2q2.2-2.3 4.5-4.5c4-2.9 8.8-5 14.9-5.8zm17.5 25c-1.1-9-6.8-16.8-16.8-16.6-17.5 0.4-18.2 25.5-7.9 33.9 4.3 3.4 14.4 4.8 19 0.2q1.3-1.1 2.4-2.4c1.6-2.2 3-4.6 3.3-8.2 0.4-1.7 0.4-5.2 0-6.9z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "path281",
    className: "s1",
    d: "m140.2 462.7c-0.1-0.2 0-0.5-0.2-0.5 3-0.5 7.1 0 10.5-0.2 0.1 0.3 0.3 0.5 0.5 0.7 5.1 9.3 12.2 18.3 18.7 27.4 1.9 2.5 4.9 7.7 6.7 8.6q0-11.7 0-23.5c0-0.4 0.2-0.9-0.2-1-0.2-1.2 0.3-3-0.2-3.8-0.1-3-0.9-5.2-1.5-7.7q0.1-0.4-0.2-0.5c3.8-0.4 9.3-0.4 13.2 0-0.8 2.8-1.7 5.4-1.7 8.9-0.6 9.9-0.1 20.9-0.2 31.2q0 0.1 0 0.3c0.1 1.2-0.4 3 0.2 3.8 0 3.3 0.7 5.8 1.9 7.9q-6.5 0-12.9 0c0-0.3 0-0.7-0.3-0.7-3.7-8.3-10.7-16.2-16.5-23.8-1.8-2.2-3.9-5.5-5.3-6.4-0.6 0.7-0.1 2.4-0.3 3.6q0 4.8 0 9.6c0.2 2.1-0.5 3.6 0 5.5 0.2 1.2-0.3 3 0.3 3.8 0 3.3 0.9 5.8 1.7 8.4q-6.6 0-13.2 0c0.7-2.7 1.6-5.4 1.6-8.9 0.4-10.8 0.4-23.4 0-34.3 0-3.7-1.6-5.7-2.6-8.4z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "path283",
    fillRule: "evenodd",
    className: "s1",
    d: "m202.4 462.2c7.1-0.5 15.2 0 22.8-0.2 5.8 0.7 10.3 2.8 14.1 5.5q1.6 1.9 3.4 3.4c3.1 4.1 5.5 8.9 6.2 15.3q0 2.2 0 4.4c-0.7 6.5-2.6 11.7-5.7 15.8q-1.4 1-2.4 2.4c-4.2 3.3-10.1 4.9-16.8 5.5q-2.3 0-4.6 0c-5.6-0.1-11.8 0.3-17-0.2 1-3.2 1.6-6.9 1.9-10.8q0-15.1 0-30.3c-0.3-3.9-1-7.5-1.9-10.8zm20.1 7.7c-2.2-0.5-5.5-0.1-8.1-0.2q0 6.7 0 13.4c-0.4 5.1-0.4 11.8 0 16.8q0 3.4 0 6.7c1.6 0.4 4.8 0.4 6.4 0 10.9 0 16.9-4.8 17.1-15.6 0.4-0.7 0.4-3.1 0-3.8-0.8-10-6-15.7-15.4-17.3z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "path285",
    className: "s1",
    d: "m324 462.5c2.5-1.1 7.1-0.2 10.4-0.5 0.2 0.3 0.4 0.7 0.7 1 7 12.5 16.1 23 24 34.8 0.2 0.4 0.6 0.8 0.9 1.2 0.4-8.4 0.4-18.5 0-26.9 0.1-3.9-0.9-6.7-1.6-9.9q0-0.1 0-0.2c4.3 0.2 9.2-0.3 13.2 0.2-1.2 2.9-1.9 6.3-2 10.4-0.4 10.3-0.4 22.3 0 32.6 0.1 3.6 0.6 6.6 2 8.9q0 0.1 0 0.2-6.5 0-13 0c-2-6.6-6.9-11.6-10.8-16.8-3.4-4.4-6.8-8.7-10.1-13.2q-0.4-0.7-1.2-1.2 0 1.8 0 3.6c-0.5 0.7-0.1 2.3-0.2 3.4q0 3 0 6c0.1 2.8-0.3 6.2 0.2 8.6 0 3.7 0.9 6.5 1.7 9.4q0 0.1 0 0.2c-4.2-0.1-9.1 0.3-13-0.2 0.8-3.3 1.9-6.4 1.7-10.6 0.4-9.6 0.4-20.9 0-30.5 0.3-4.7-1.5-7.4-2.9-10.5z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "path287",
    className: "s4",
    d: "m176.4 498.7c-0.4-7.3-0.4-16.2 0-23.5q0 11.8 0 23.5z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "path321",
    className: "s6",
    d: "m127.2 536.9c44.1 0 94.2 0 140.2 0 3.3 0 7.1-0.6 9.1 0 0.7 0.2 0.4-0.2 0.3 0.7-1.1 2.4-2.4 4.5-3.2 7.2-0.6 0.1-0.4 1-0.9 1.2-48.4-0.2-97.5 0.3-145.5-0.2q0-4.5 0-8.9z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "path323",
    className: "s2",
    d: "m394.4 178.6c1.3-1.5 2.6-3.2 4.5-4.1-0.3 0.4-0.5 0.9-1.2 0.9-1.2 0.9-2.1 2.3-3.3 3.2z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "path325",
    className: "s2",
    d: "m379.5 194.9q1.3-1.6 2.9-2.9-1.3 1.6-2.9 2.9z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "path327",
    className: "s3",
    d: "m191.6 67q1.3 1 2.4 2.4-1.4-1.1-2.4-2.4z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "path329",
    className: "s3",
    d: "m192 75.8c-0.8-0.8-1.6-1.7-2.4-2.6q1.5 1.1 2.4 2.6z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "path331",
    className: "s2",
    d: "m224 65.5c0.4 0.1 0.1 1 0.9 0.7 0.7-0.9-0.2-3.4 0.5-4.3q0 2.2 0 4.3c-0.7 0.4-1.4 0.2-1.4-0.7z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "path335",
    className: "s2",
    d: "m109 56.2q1 1.3 2.4 2.4c0.6-0.1 0.7 0.3 1 0.7q-2.8-1.4-4.1-4.1c0.3 0.2 0.7 0.4 0.7 1z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "path337",
    className: "s3",
    d: "m292.1 59c0.6-0.9 1.7-1.4 2.4-2.1-0.6 0.9-1.5 1.5-2.4 2.1z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "path339",
    className: "s3",
    d: "m265 58.1c0.7-1.1 1.8-1.8 2.6-2.7 0.5-0.3 1-0.6 1.5-0.9-1.3 1.3-2.8 2.3-4.1 3.6z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "path341",
    className: "s3",
    d: "m111.4 58.6q-1.3-1.1-2.4-2.4 1.4 1 2.4 2.4z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "path343",
    className: "s1",
    d: "m262.6 66c1.7-0.7 3.5-1.3 5.3-1.9-2.5 3.8-6.4 8.4-6.5 15.3 1.7-0.5 3.4-1.1 5.3-1.4q1.7 0 3.3 0c2.4 0.5 4.5 1.3 6.5 2.2 0.5 1.1-3.2-0.1-3.8 0.7-14.4 1.2-19.9 11.3-33.4 13.4 2.4 0.6 5.1 0.7 7.9 0.7 2.8 0.4 7.3 0.4 10.1 0 7.2-0.1 12.7-2 16.1-6 2.5 2.2-0.2 4.8-1.7 6.3 6.1 1.5 10.8 4.6 12.7 10.3-0.8 0.2-1.7-0.8-2.6-1.4-2.9-1.9-6.8-3.7-11.3-3.9-1.5-0.4-4.7-0.4-6.2 0q-0.7 0-1.5 0c0.5 2.2 1.7 3.5 2 5.8 0.4 0.9 0.2 2.3 0.2 3.6-0.2-0.1-0.2-0.3-0.5-0.3-7.2-9.5-22.5-11-37.4-12.9 8.5-4.6 19.2-7 22.5-16.8 0.4-0.8 0.4-3.3 0-4.1 0-2.1-2.1-3.4-2.4-4.6 4.1 0.8 7.4 2.3 7.5 7 1.7-2.7 2.4-6.3 4.3-8.9 1.2-1 2.3-2.1 3.6-3.1z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "path345",
    className: "s3",
    d: "m140.7 65.5c1.6 0.8 3 1.8 4.1 3.1-1.2-1.2-2.8-2-4.1-3.1z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "path347",
    className: "s3",
    d: "m156.8 84.2q1.6 1.3 2.8 2.9-1.6-1.3-2.8-2.9z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "path349",
    className: "s3",
    d: "m139.5 109.4c0.7-1.2 1.8-2.2 2.9-3.1q-1.4 1.6-2.9 3.1z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "path351",
    className: "s1",
    d: "m137.6 78c1.7 0.5 3.4 0.8 5 1.4 0.1-6.1-3.2-11-6.2-14.8 1.4-0.6 2.7 0.9 4.3 0.9 1.3 1.1 2.9 1.9 4.1 3.1 1.8 2.8 3.2 6 4.3 9.4 0.8-4.1 3.4-6.3 7.7-7 0.4 0.9-1.4 1.7-2 2.9-1.6 3.5-0.2 8.1 2 10.3q1.3 1.6 2.8 2.9c5.1 3.8 11.2 6.7 17.6 9.1-13 2-26.6 3.4-34.8 10.1-1.1 0.9-2.2 1.9-2.9 3.1-1.1-2.6 1-6.3 1.7-8.8 0-0.6-0.9-0.1-1.2-0.3-1.6-0.4-4.8-0.4-6.3 0-6.1 0.5-10.3 2.8-13.9 5.8 1.2-5.6 6.1-9.6 12.7-10.6-1.2-1.7-4.3-4-1.9-6.5 3.6 3.9 9 5.9 16.3 6 2.7 0.4 7.1 0.4 9.9 0 3 0.2 5.3-0.4 8.1-0.4-6.3-2.3-11.6-3.9-16.8-7-5.3-3.2-9.1-6.9-17.3-7q-1.6 0-3.3 0c1.5-1.4 4-2 6.5-2.6q1.8 0 3.6 0z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "path355",
    className: "s3",
    d: "m259 69.1c1-1.2 2.1-2.4 3.6-3.1-1.3 1-2.4 2.1-3.6 3.1z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "path357",
    className: "s4",
    d: "m58.1 171.6c0.6 0.2 0.7 0.8 1.2 1 0.8 0.8 1.8 1.4 2.4 2.4-1.3-1.1-2.6-2.1-3.6-3.4z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "path359",
    className: "s2",
    d: "m74 193.9c1.5-1.7 3.1-3.4 5-4.8-0.2 0.9-1.1 1.2-1.7 1.7-1.2 0.9-2.1 2.2-3.3 3.1z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "path361",
    className: "s2",
    d: "m56.2 207.4q1.8-2.1 3.8-3.9-1.7 2.1-3.8 3.9z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "path365",
    className: "s2",
    d: "m81.4 208.8q1.3-1.6 2.9-2.9-1.3 1.6-2.9 2.9z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "path373",
    className: "s2",
    d: "m105.9 208.6c-0.8 1-1.6 1.9-2.4 2.8 0.9 0.2 2.5-0.3 3.1 0.3q-1.8 0-3.6 0c0.2-1.1 1.3-1.3 1.7-2.2 0.5-0.1 0.6-0.8 1.2-0.9z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "path399",
    className: "s2",
    d: "m327.6 191.5q-1.6-1.3-2.8-2.9 1.6 1.3 2.8 2.9z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "path417",
    className: "s4",
    d: "m130.4 143.5q1.2-1.6 2.8-2.9c-0.6 0.8-1.2 1.6-1.9 2.2-0.5 0.1-0.4 0.6-0.9 0.7z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "path419",
    className: "s2",
    d: "m124.6 149.3q2.7-3.1 5.8-5.8-2.8 3.1-5.8 5.8z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "path421",
    className: "s2",
    d: "m127.7 153.8c0.4-0.7 1.3-1.1 1.7-1.9q0.6-0.9 1.4-1.4c-0.7 1.4-2 2.3-3.1 3.3z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "path423",
    className: "s2",
    d: "m156.3 145.9c-0.7 0.1 0.2-1.3-0.5-1.2 0.3-0.4 2.4-0.5 2.4 0.3-0.6-0.1-0.9-0.4-1.7-0.3-0.5 0-0.1 0.9-0.2 1.2z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "path427",
    className: "s2",
    d: "m75.9 120.5c0-0.3 0.4-0.3 0.7-0.3-0.2 1.5 0.3 3.6-0.2 4.6-0.3-1.3 0.6-3.8-0.5-4.3z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "path429",
    className: "s2",
    d: "m105.2 139q0.7-0.1 0.7 0.7c-1.1-0.2-2.7 0.3-3.4-0.3q1.3 0 2.7 0c0.1 0 0.2-0.2 0-0.2q0-0.1 0-0.2z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "path431",
    className: "s3",
    d: "m116.4 127c0.9-1.4-2.4-2.8-1.4-3.4 0.3 1.4 2.9 2.1 1.7 3.4q-0.1 0-0.3 0z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "path433",
    className: "s2",
    d: "m78 99.4c0.6-1.4 0.6 1.7 0.5 2.6-0.7-0.3 0.2-2.3-0.5-2.6z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "path435",
    className: "s3",
    d: "m65.8 123.6q1.3-1.6 2.9-2.9-1.3 1.6-2.9 2.9z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "path437",
    className: "s2",
    d: "m109.7 134.9c0.4 0.3 1 0.5 1 1.2-0.8-0.2-2.2 0.3-2.7-0.3 1.6 0.1 3.1 0.2 1.7-0.9z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "path439",
    className: "s3",
    d: "m71.3 127q1.1-1.4 2.4-2.4-1 1.3-2.4 2.4z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "path441",
    className: "s2",
    d: "m136.6 222.5c0.5-0.3 0.8-0.6 1.4-0.7-0.6 0.4-0.4 1.7-0.4 2.8-0.8-0.2 0.5-2.6-1-2.1z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "path443",
    className: "s1",
    d: "m40.6 101.8c7.1-9.4 11.3-21.7 15.4-34.1 0.2 5-1.9 11.7-1.7 18.2-0.6 1.5-0.1 4.1-0.3 6 0.1 1.7-0.1 4.1 0 5.1 0.2 1.8-0.3 4.3 0.3 5.7 1.1 20 6.5 35.7 16.3 47.1-2.4-7.6-10.3-17.4-4.8-26.2q1.6-1.3 2.9-2.9c0.1-2.3-1.6-2.8-2.2-4.3 1.6-1.4 1-4.9-0.5-6 1.1-1.4 2.7-4.5 1-6.5 2.1-3.1 2.6-7.8 5.8-9.8-0.4 4.7 2.1 6.6 3.8 9.3 0.4-1.4 0.3-3.3 1.4-4 0.7 0.3-0.2 2.3 0.5 2.6 1 3.7 4.7 5.8 3.4 11q5.8-1.6 12.2-2.6c1.1 0 2.4-0.1 3.1 0.2 4.6 4.1-11.3 3.3-11.7 6.3 2.6 1.1 6 4.4 9.3 2.6 0.5-0.6 0.2-1.9 0.3-2.9 2.6-1.7 6.7-2 10.5-2.6q3.3 0 6.5 0c2.4 0.4 5.1 0.6 7 1.4-0.8 0.3-2.9-0.2-4.3 0-0.1 8.4-7.1 8.3-15.6 9.6-4.2 0.7-14.8 0.8-11.3 5.8 3.4-0.5 6.3-0.1 9.1-0.7 2.6-0.6 4.8-2.8 7.7-2.7q1.2 0 2.4 0c3 1 7 1.5 9.3-0.4q0.2 0 0.3 0c1.2-1.3-1.5-2-1.7-3.4 0.6 0 0.7 0.4 1.4 0.2 0.7 0.4 3 0.4 3.6 0 1.4 0.2 2.1-1.4 2.7-1.2-0.3 4.7-3.5 6.4-6.7 8-0.8-0.8 0.5-1.6 0.4-2.4-2.3 1-5.1 1.8-8.1 0.9-0.6 2.1 0.5 4.4 1.4 5.8 1.4 1.1-0.1 1-1.7 0.9-1.3-0.3-2.5-0.8-3.8-1.2-0.4 1.2 0.2 3.5 1 4.4q0 0.1 0 0.2c0.2 0 0.1 0.2 0 0.2q-1.4 0-2.7 0c-7.5-1.4-13.9-4-22.8-4-1.2-2.4-2.3-4.9-5-5.8 0.7-1.5 1.7-2.6 1.7-4.8 0.5-1 0-3.1 0.2-4.6-0.3 0-0.7 0-0.7 0.3-0.6 1.4-1.5 2.6-2.2 4.1q-1.3 1-2.4 2.4c-1.3 0.6-2.6 1.3-4.3 1.6 3.8 2.8 7.6 5.6 8.6 11.1 2.1-0.1 3.5-0.8 5.6-0.3-2.7 1.3-4.4 4.6-2.7 8 1.2 2.3 4.7 3.9 7.5 6 15.6 11.3 30.6 22 46.5 33.3 2.5 1.8 6.1 4 7.5 5.8 2.5 3.4 2.8 9.3 3.6 13.4-0.1 0.2 0 0.2 0.2 0.3 0.1 2-0.1 3.7-0.2 5.5-0.6 4.6-2.3 8.1-5.6 10.1-0.6 0.1-1 0.4-1.4 0.7-1 0.2-2.1 0.3-2.9 0.7-1 0-2 0-2.6-0.2-1-0.3-1.7-0.8-2.4-1.2 1-0.2 1.5-1.1 1.9-2 1.3-0.7 4 0 3.4-2.6-1.9-0.2-4.3 0-5.3-1.4 1.5 0 1.8-1.2 2.4-2.2 2.2-0.7 4.2 0 5.5-1.9 2.2-3.3 0.4-10.4-2.4-11.5-2-0.6-3.6 0.6-5 0.4-1.3-0.1-2.4-2-3.2-0.4 0.3-3.2 4.8-4.2 7.7-5.6-3.8-2.9-8.8-4.6-13.4-6.7-4.3 6.5-8.3 13.3-13.2 19.2q-1.4 1.1-2.4 2.4c-0.4 0.9-1.5 1.1-1.7 2.2q1.8 0 3.6 0c4.3 0.7 8.4 0.6 10.8 2.9 6.1 5.8-1 15.7-4.6 20.1-1.8 1.6-3.3 3.6-5 5.3-0.2 0-0.2 0.2-0.5 0.2q-1.3 1.1-2.4 2.4 0 0.2 0 0.3c-1.6 1.4-2.8 3.2-3.3 5.7-0.4 0.8-0.4 3.1 0 3.9 0.7 3 3.5 4.9 6.9 6.2 5.8 2.2 8.9 2.3 14.2 0.3 2.1-0.8 3.8-2.2 5.7-2.4q1.2 0 2.4 0c3.6 0.8 7.3 2.6 6.3 7.2-1-0.4-1-1.7-1.9-2-2.6 1.9-3.1-1.5-6-0.4 0.5 1.5 2.1 2.4 1.4 4.5-0.8 0.6-0.8-1.4-1.7-1.4-0.7 0-1 0.5-1.9 0.5-8.5-2.4-17.5 4.9-24 7.2 0.3-2.8 2.2-3.9 3.8-5.3 0.1-0.7-0.4-0.8-0.7-1.2q-1.3-1.6-2.9-2.9c-1.8-1.7-3.8-3.5-6.9-5.5-2-1.3-6.8-2.8-7.2-5.1-0.8-4 4.3-6 6-8.8q3.1-2.9 6-6c0.2-0.4 0.6-0.5 0.7-1q1.6-1.3 2.9-2.9c1.9-2.8 7.1-6.9 7.7-11.3 0.6-5.6-8.4-4.6-13.7-5-5.2-0.4-9.3-0.5-13.7-1 6.9-3.4 13.3-7.3 18-12.9q1.3-1.1 2.4-2.4c3.6-4.3 7-8.9 9.6-14.2-2.1-1.1-4.2-1.1-6.5-0.9-2.5 0.1-5.3 1.8-6.9 1.6-2.7-0.2-4.4-3.9-7.2-4.3-0.4 2.3 2.1 4 2.1 6 0 2.1-2.9 5-4.3 7-1.8 2.5-3.5 4.8-4.8 6.5q-3.3 2.9-6.2 6.2c-6.8 7.5 2.8 15.2 3.6 22.3 0.8 8.3-4.1 13.9-7.5 19.2-0.6 0.6-1.4 1-1.7 1.9q-2.3 2-4.3 4.4c-1 0.3-1.5 1.2-2.1 1.9-5.4 4.3-11.2 8.2-17.3 11.7 1.9 6 4.5 11.2 6.7 16.8 4.7-0.7 7.6-3.3 12-4.3q1.3 0 2.6 0c3.1 0.5 5.6 2.7 4.6 6.5-1-0.2-0.7-1.7-1.7-1.9-1.9 1.3-2.3 0.2-5 0.2 0.3 2 1.3 2.9 0.5 4.8-1 0-0.6-1.3-1.5-1.4-1.8 0.8-3.3-0.1-5 0-3.4 0-6.6 2.2-9.9 3.3-3.3 1.2-6.3 2.6-10.3 2.7 0.1-0.9 0.9-1.1 1.2-1.7 0.9-0.8 1.9-1.4 2.7-2.4 0.6 0 0.8-0.4 1.2-0.7-0.6-7.3-1.9-14.4-4.4-21.1-0.6-1.8-2.5-4.6-2.4-6 0.4-3.3 8.3-4.5 10.4-6.5 2.4-2.4 2.6-10.4 3.3-15.1 0.7-4.3 1.3-8.5 2.2-12.5 1.9-8.5 5.9-14.6 7.4-21.9-2.5 0.8-3.9 3.6-5.3 5.8-3.8 6.5-6.6 16.1-7.4 25.4-0.1 1.3 0.1 2.3-0.2 3.4-0.6 1.6-3.7 3.8-5.3 4.8-3.2 2-7.6 3.2-12 3.8q-1.2 0-2.4 0c-8.3-1-15.3-5.9-14.4-15.8 0.9-10.3 10.8-14.1 11.5-20.9 0.4-3.5-0.8-6.7-3.6-6.9-5-0.4-5.9 7.4-0.5 7.4-0.7 1.9-1.6 3.6-3.1 4.8-3.3-0.9-5.3-3.2-6-6.7-0.3-0.8-0.2-2-0.2-3.1 1-4.3 3.7-6.9 7.9-8q1.2 0 2.4 0c4.9 1.2 8.3 3.9 8.9 9.4q0 1.3 0 2.6c0.7 7.3-8.3 15.4-8.2 22.4 0.1 5.4 7.9 6.1 12 3.3q1.4-1 2.4-2.4c5.9-8.8 5.6-23.6 13.2-30.7q2.2-1.9 4.1-4.1c1.4-0.7 2.3-2 3.6-2.9-4.1-2.9-8.6-5.5-15.1-6 7.1-5.4 18.7 6.1 24.9-0.2q2-1.7 3.6-3.6c0.6-0.5 1.5-0.8 1.7-1.7 7.5-8.9 0.6-24.3-4.1-31.2-1.9 2.5-3.1 4.8-6.5 6.5-1.8 0.9-4.6 1.3-4.8 3.1-0.1 2.4 5 5.3 6.8 6.5 2.2 1.5 6.9 3.6 6.9 6 0.1 5.4-7.8 0.3-9.3-0.7-2.6-1.7-4.5-3.1-6.3-4.3-0.6-1-1.6-1.6-2.4-2.4-0.8-0.9-1.5-1.9-2.4-2.7-1.9-2.8-3-6.6 0.3-8.9 3.2-2.1 8.8-1.5 6.2-7.9-1.4-3.4-4.9-6.7-7.4-9.6-17.6-20.3-36.3-45.2-45.9-72.2 2.3 2.1 3.4 5 4.8 7.7 10.2 18.4 21.9 36.2 36.3 50.8-3.7-8.7-8.1-16.7-12.3-24.9 0-0.2 0-0.5-0.2-0.5 0-1.5 1.4-1.6 1.9-2.6z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "path445",
    className: "s3",
    d: "m104.7 209.5q1-1.3 2.4-2.4c-0.3 0.7-1 0.8-1.2 1.5-0.6 0.1-0.7 0.8-1.2 0.9z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "path455",
    className: "s3",
    d: "m103 203.3q1.1-1.4 2.4-2.4-1 1.3-2.4 2.4z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "path457",
    className: "s3",
    d: "m81.2 208.8q2.9-3.3 6.2-6.2c-0.9 1.2-2.2 2.1-3.1 3.3q-1.6 1.3-2.9 2.9-0.1 0-0.2 0z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "path461",
    className: "s3",
    d: "m46.1 295.2c0.7-1 1.7-1.7 2.7-2.4-0.8 1-1.8 1.6-2.7 2.4z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "path465",
    className: "s3",
    d: "m56.2 207.4q2.1-1.8 3.8-3.9 0.2 0 0.3 0-1.9 2.2-4.1 4.1 0-0.1 0-0.2z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "path467",
    className: "s3",
    d: "m73.7 194.4c0.1-0.2 0.3-0.2 0.3-0.5 1.2-0.9 2.1-2.2 3.3-3.1q-1.6 2-3.6 3.6z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "path469",
    className: "s3",
    d: "m59.3 172.6c-0.5-0.2-0.6-0.8-1.2-1-0.4-0.6-0.8-1.1-1.2-1.7 0.9 0.8 1.6 1.8 2.4 2.7z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "path471",
    className: "s3",
    d: "m38.9 104.9c-1.3-1.3 1-2.4 1.7-3.1-0.5 1-1.9 1.1-1.9 2.6 0.2 0 0.2 0.3 0.2 0.5z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "path473",
    className: "s3",
    d: "m353.3 129.1c0.4 0.5 0.9-0.9 1.5-0.9-0.5 0.4-1.3 1.9-2 1.4 0.4 0 0.3-0.4 0.5-0.5z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "path475",
    className: "s3",
    d: "m324.5 188.6q0.1 0 0.3 0 1.2 1.6 2.8 2.9c0.4 0.7 1.1 1 1.5 1.7q-2.4-2.1-4.6-4.6z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "path489",
    className: "s3",
    d: "m305.6 185.8c0.6-0.8 1.5-1.2 2.4-1.7-0.7 0.7-1.6 1.2-2.4 1.7z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "path501",
    className: "s3",
    d: "m300.5 211c-0.7-1.1-1.9-1.8-2.6-2.9q1.7 1.4 3.1 3.1c-0.2 0-0.2-0.2-0.5-0.2z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "path503",
    className: "s3",
    d: "m274.6 221.3q0.6 0 1.2 0c-0.4 0.6-0.9 1.1-1.7 1.4 0.2-0.6 1.1-0.5 1.2-1.2-0.3 0-0.7 0.1-0.7-0.2z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "path505",
    className: "s3",
    d: "m264.8 221c0.9 0.2 1.4 0.8 2.1 1.2q-0.2 0-0.5 0c-0.6-0.2-0.9-0.8-1.6-0.9q0-0.1 0-0.3z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "path507",
    className: "s3",
    d: "m264.5 192c0.6-0.9 1.6-1.3 2.4-1.9-0.6 0.8-1.6 1.3-2.4 1.9z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "path509",
    className: "s3",
    d: "m326.2 132.2c0.9-0.9 1.6-2 2.9-2.6-1 0.8-1.9 1.8-2.9 2.6z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "path513",
    className: "s3",
    d: "m337 108.7c0.6 0.3 0.8 1 1.4 1.2-0.2 0.5-0.4 1-0.9 1.2 0.2-0.4 0.6-0.7 0.7-1.2q-0.8-0.4-1.2-1.2z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "path517",
    className: "s3",
    d: "m220.8 76.6q1.2-1.5 2.7-2.7-1.2 1.5-2.7 2.7z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "path519",
    className: "s3",
    d: "m291.6 89.5c-0.6-0.3-0.9-1-1.4-1.4-1 0.6-1.5 1.9-2.9 2.1 1-0.7 1.6-1.9 2.9-2.4 0.7 0.4 0.9 1.2 1.4 1.7z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "path521",
    className: "s3",
    d: "m111.4 80.6q1.4-1.7 3.1-3.1-1.4 1.7-3.1 3.1z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "path523",
    className: "s3",
    d: "m296.9 85.9q1.5 1.2 2.7 2.7-1.5-1.2-2.7-2.7z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "path525",
    className: "s2",
    d: "m209.6 94.8c0.3 0.1 0.2 0.6 0.2 1-0.6 0.3-3.8 0.3-3.6 0 1.1-0.1 2.6 0.2 3.4-0.3q0-0.3 0-0.7z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "path527",
    className: "s2",
    d: "m155.3 113.5c1.2-1.4 2.5-2.6 4.1-3.6-0.4 0.5-0.6 1.1-1.4 1.2-1.1 0.7-1.7 1.8-2.7 2.4z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "path529",
    className: "s2",
    d: "m150.8 121.9q0 0.3 0 0.5c1.3-0.4 1.7-1.8 2.8-2.4-0.8 0.6-2.3 3.6-3.1 1.9q0.1 0 0.3 0z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "path531",
    className: "s2",
    d: "m172.4 109q1.7-2.1 3.8-3.9-1.8 2.1-3.8 3.9z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "path533",
    className: "s3",
    d: "m204.8 125.3c0.7-0.7 1.8-1 2.6-1.5-0.6 0.8-1.6 1.1-2.6 1.5z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "path535",
    className: "s3",
    d: "m188.7 127q-1.4-1.1-2.4-2.4 1.3 1 2.4 2.4z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "path537",
    className: "s4",
    d: "m245.3 110.2c1.7 1.2 3.2 2.5 4.3 4.3-1.4-1.4-2.9-2.8-4.3-4.3z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "path539",
    className: "s3",
    d: "m171.9 109.2c1.9-2.2 3.9-4.2 6.2-6-0.4 0.9-1.3 1.2-1.9 1.9q-2.1 1.8-3.8 3.9c-0.2 0-0.3 0.2-0.5 0.2z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "path541",
    className: "s3",
    d: "m151 121.7c0.7 0.7 2-2 3.1-2.4-0.1 0.3-0.4 0.4-0.5 0.7-1.1 0.6-1.5 2-2.8 2.4q0-0.2 0-0.5c-0.1-0.2 0.1-0.2 0.2-0.2z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "path543",
    className: "s3",
    d: "m155.3 113.5c1-0.6 1.6-1.7 2.7-2.4q-1.2 1.5-2.7 2.7 0-0.2 0-0.3z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "path545",
    className: "s3",
    d: "m253.5 122.2c-0.1 0.4-1.9-1.5-2.4-2.2 0.9 0.6 1.4 1.6 2.4 2.2z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "path547",
    className: "s3",
    d: "m231.9 108.5q-1.7-1.4-3.1-3.1 1.7 1.4 3.1 3.1z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "path551",
    className: "s2",
    d: "m46.1 179q1.7 2 3.6 3.6 1.1 0.5 1.7 1.5-4-2.7-6.7-6.7 1 0.5 1.4 1.6z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "path553",
    className: "s4",
    d: "m355.2 181.9q1.1-1.3 2.4-2.4-1 1.4-2.4 2.4z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "path555",
    className: "s3",
    d: "m353.6 183.4q2.5-2.8 5.2-5.3c-0.2 0.6-0.9 0.8-1.2 1.4q-1.3 1.1-2.4 2.4c-0.7 0.4-0.9 1.1-1.6 1.5z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "path557",
    className: "s3",
    d: "m350.9 176.6q1.7-1.9 3.6-3.6-1.6 2-3.6 3.6z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "path559",
    className: "s3",
    d: "m49.7 182.6q-1.9-1.6-3.6-3.6 2 1.7 3.6 3.6z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "path561",
    className: "s3",
    d: "m12.5 163.9q1.5-1 3.4-1.7-1.5 1.1-3.4 1.7z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "path563",
    className: "s3",
    d: "m242.4 141.8c1-1 1.8-2.2 3.2-2.8-1.1 0.9-2 2-3.2 2.8z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "path567",
    className: "s3",
    d: "m274.4 144.5c0.6 0.2 0.8 0.9 1.4 1.2 0.9 1.2 2.2 2.1 3.1 3.3q-2.4-2.1-4.5-4.5z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "path571",
    className: "s3",
    d: "m266.7 155.8c-0.1 0.2-0.5 0.2-0.7 0.2 0.6-0.8 1.8-1.6 0.4-2.4 1.9 0.3 0.1 1.8 0.3 2.2z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "path573",
    className: "s3",
    d: "m190.6 151.2c-1.1-0.5-1.7-1.3-2.4-2.2 0.8 0.7 1.6 1.5 2.4 2.2z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "path575",
    className: "s3",
    d: "m127 154.3q1-1.3 2.4-2.4c-0.4 0.8-1.3 1.2-1.7 1.9-0.3 0.1-0.4 0.5-0.7 0.5z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "path577",
    className: "s3",
    d: "m110.4 156.2q-1.9-1.6-3.6-3.6 2 1.7 3.6 3.6z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "path579",
    className: "s3",
    d: "m124.4 149.8c0-0.2 0.2-0.3 0.2-0.5q3-2.7 5.8-5.8c0.4-0.1 0.4-0.6 0.9-0.7q-3.3 3.6-6.9 7z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "path581",
    className: "s3",
    d: "m381.4 129.4c0.6-1 1.6-1.7 2.6-2.2-0.7 0.8-1.8 1.4-2.6 2.2z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "path583",
    className: "s4",
    d: "m15.2 152.6c0.7 1.8-0.3 5.2 0.4 7-1-1.4-0.2-4.8-0.4-7z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "path585",
    className: "s3",
    d: "m217.5 142.1q1.8-2.1 3.8-3.9c0 0.4-0.4 0.4-0.5 0.8-1.2 0.9-2.1 2.2-3.3 3.1z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "path589",
    className: "s2",
    d: "m136.1 156.7c2.5 0.5 0.6 5.3 1.2 7.7q0 4.2 0 8.4c-0.1 5 0.3 12-0.2 15.8 0-7.7 0-17 0-24.7 0-2.4 0.7-5.5-1-7.2z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "path593",
    className: "s2",
    d: "m25 171.8q1.8 1.6 3.4 3.4-1.9-1.5-3.4-3.4z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "path595",
    className: "s2",
    d: "m371.8 174.2c1.7-1.8 3.3-3.7 5.5-5-0.4 0.5-0.6 1.1-1.4 1.2-1.5 1.1-2.6 2.7-4.1 3.8z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "path597",
    className: "s4",
    d: "m375.6 175.2c1.1-1.4 2.2-2.6 3.6-3.6q-1.6 2-3.6 3.6z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "path599",
    className: "s3",
    d: "m30.5 172.6c0.6 0.9 1.6 1.5 2.2 2.4-0.8-0.8-1.8-1.3-2.2-2.4z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "path601",
    className: "s3",
    d: "m37.7 186.5c0.9 0.2 0.6 1.4 1.7 1.4 0.1-0.3 0.3-0.4 0.5-0.5-0.2 0.4-0.4 0.8-1 0.8-0.4-0.6-0.8-1.1-1.2-1.7z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "path603",
    className: "s3",
    d: "m29.6 176.2c-0.6-0.2-0.7-0.8-1.2-1q-1.6-1.8-3.4-3.4c-0.2-0.5-0.8-0.6-1-1.2q2.9 2.7 5.6 5.6z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "path605",
    className: "s3",
    d: "m379.2 171.6q1.1-1.4 2.4-2.4-1 1.4-2.4 2.4z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "path607",
    className: "s3",
    d: "m373 177.8q1.2-1.4 2.6-2.6-1.1 1.5-2.6 2.6z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "path609",
    className: "s3",
    d: "m371.8 174.2c1.5-1.1 2.6-2.7 4.1-3.8q-1.9 2.2-4.1 4.1 0-0.1 0-0.3z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "path611",
    className: "s2",
    d: "m29.6 195.1c-1.3-0.9-2.1-2.2-3.4-3.1-0.8-0.1-1-0.7-1.4-1.2 1.8 1.2 3.4 2.7 4.8 4.3z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "path613",
    className: "s4",
    d: "m9.4 178.6c-0.7-1.1-1.9-1.8-2.6-2.9q1.5 1.3 2.8 2.9-0.1 0-0.2 0z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "path615",
    className: "s3",
    d: "m5.8 175c0.5 0 0.5 0.6 1 0.7 0.7 1.1 1.9 1.8 2.6 2.9q-2-1.7-3.6-3.6z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "path617",
    className: "s1",
    d: "m9.6 178.6c1.7 2.4 7.3 4.4 10.4 1.9-0.1 2.4-2.8 4.3-6 4.3 3.6 1.9 7.5 3.7 10.8 6 0.4 0.5 0.6 1.1 1.4 1.2q1.5 1.8 3.4 3.4c1.3 2 2.7 3.9 4 6-1.4-0.2-3.5-1.8-5.7-2-3.2-6.3-8.7-10.2-14.9-13.4 0.5 1.8 2.2 4.9 1 7.9-1.7-3.2-5-5.5-6.5-9.6-1.7-4.6-2.6-9-7-10.8 1.9-1.3 3.9 0.8 5.3 1.5q1.7 1.9 3.6 3.6 0.1 0 0.2 0z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "path619",
    className: "s3",
    d: "m26.2 192c1.3 0.9 2.1 2.2 3.4 3.1q0 0.1 0 0.3-1.9-1.6-3.4-3.4z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "path621",
    className: "s3",
    d: "m379 195.1q1.7-1.9 3.6-3.6c0 0.2-0.2 0.3-0.2 0.5q-1.6 1.3-2.9 2.9c-0.2 0-0.3 0.2-0.5 0.2z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "path623",
    className: "s1",
    d: "m398.9 174.5c1.4-0.5 2.7-2 4.6-1.2-4.7 2.1-5.3 7.8-7.7 12.7-1.6 3.3-4.2 4.9-5.5 7.9-1.2-2.7-0.1-6 0.9-7.9-3.3 1.4-5.9 3.5-8.6 5.5q-2 1.7-3.6 3.6c-1 1.4-2.2 2.5-2.6 4.3-2.3 0.6-4.5 1-5.8 2.4 3.4-7.7 10.8-13.4 19.4-16.8-2.8-0.7-5.5-1.4-6-4.5 2.9 2.3 8.3 0.8 10.1-1.5q2-1.6 3.6-3.6c0.7 0 0.9-0.5 1.2-0.9z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "path625",
    className: "s3",
    d: "m394.1 179c0.1-0.2 0.3-0.2 0.3-0.4 1.2-0.9 2.1-2.3 3.3-3.2q-1.6 2-3.6 3.6z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "path627",
    className: "s1",
    d: "m50.4 188.6c-0.3 1.6-1.9 1.1-2.8 1.5-3.6 1.2-6.7 3.6-9.4 5.7 0.7-2.5 8.3-10.1 12.2-7.2z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "path629",
    className: "s3",
    d: "m362 190.8q1.6 1.3 2.8 2.9-1.6-1.3-2.8-2.9z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "path631",
    className: "s2",
    d: "m164 284.4q1.4 1.2 2.6 2.6-1.5-1.1-2.6-2.6z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "path633",
    className: "s2",
    d: "m167.1 287.5c1.2 0.9 2.1 2.2 3.3 3.1q1.6 1 2.7 2.4c-2.1-1.7-4.3-3.3-6-5.5z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "path635",
    className: "s2",
    d: "m237.2 281.8q2.2-2.6 4.8-4.8-2.3 2.5-4.8 4.8z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "path637",
    className: "s4",
    d: "m162.3 277.2q2.2 1.9 4.1 4.1c-0.4-0.1-0.4-0.4-0.8-0.5q-1.1-1.5-2.6-2.6c-0.1-0.5-0.6-0.5-0.7-1z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "path639",
    className: "s1",
    d: "m242.9 276.2c11-12.1 19.6-26.6 22.8-46.5 0-0.5 0.2-0.5 0.3-0.3-3.1 23.3-12.9 39.6-25 53.8q-1.6 1.3-2.9 2.9-1.3 1.6-2.9 2.9-1.7 1.4-3.1 3.1c-9 7.5-18.6 14.4-30 19.7-5.2-2.3-9.8-5.2-14.6-8-0.7-0.8-1.8-1.2-2.7-1.9-4.2-2.7-7.8-5.9-11.7-8.9q-1.1-1.4-2.7-2.4-3.1-3.3-6.4-6.4c-12.4-14.3-22.6-30.6-25.7-54 3.8 19.8 12.2 35.1 24 47 0 0.5 0.6 0.5 0.7 1q1.2 1.4 2.6 2.6c0.4 0.1 0.4 0.4 0.8 0.5q1.1 1.4 2.6 2.6c2 1.6 3.8 3.5 6 4.8 0.6 0.9 1.6 1.3 2.4 1.9 5.4 4 11.1 7.6 18 10.8 1.8 0.9 4.7 2.9 6.5 2.9 2.1 0.1 5.8-2.4 8.1-3.6 7.9-3.9 15.1-8.4 21.4-13.7 0.9-0.7 2-1.3 2.6-2.4 1.2-0.2 1.5-1.4 2.4-1.9q3.4-3.1 6.5-6.5z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "path641",
    className: "s3",
    d: "m163 278.2q1.5 1.1 2.6 2.6-1.4-1.2-2.6-2.6z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "path643",
    className: "s3",
    d: "m166.4 281.3q1.4 1.1 2.6 2.6-1.5-1.1-2.6-2.6z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "path645",
    className: "s3",
    d: "m175 288.7c0.8 0.6 1.8 1.1 2.4 1.9-0.8-0.6-1.8-1-2.4-1.9z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "path647",
    className: "s3",
    d: "m231.4 287c0.7-1 1.8-1.5 2.6-2.4-0.6 1.1-1.7 1.6-2.6 2.4z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "path649",
    className: "s3",
    d: "m236.4 282.7c0.1-0.5 0.7-0.4 0.8-0.9q2.5-2.3 4.8-4.8c0.5-0.1 0.4-0.7 0.9-0.8q-3.1 3.4-6.5 6.5z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "path651",
    className: "s3",
    d: "m238.1 286.1q1.3-1.6 2.9-2.9-1.3 1.6-2.9 2.9z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "path653",
    className: "s3",
    d: "m232.1 292.1q1.4-1.7 3.1-3.1-1.4 1.7-3.1 3.1z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "path655",
    className: "s3",
    d: "m187.5 303.8c-1-0.5-2-1-2.7-1.9 0.9 0.7 2 1.1 2.7 1.9z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "path657",
    className: "s3",
    d: "m170.4 290.6c-1.2-0.9-2.1-2.2-3.3-3.1-0.1-0.2-0.2-0.4-0.5-0.5q-1.2-1.4-2.6-2.6 0-0.1 0-0.2 3.3 3.1 6.4 6.4z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "path663",
    className: "s3",
    d: "m99.4 300c0.6-0.9 2-1.1 2.9-1.7-0.7 0.9-2 1.1-2.9 1.7z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "path667",
    className: "s3",
    d: "m366.8 324.5q1.5-1.5 3.1-2.9c-0.9 1.1-1.9 2.1-3.1 2.9z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "path669",
    className: "s1",
    d: "m369.9 321.6c1.6-2.3 3-5 3.3-8.6-0.1 10.6-5.1 17.1-18 16.3-8.7-0.6-16.9-4.3-24.4-7.7-21.2-9.7-41.2-25.4-68.2-27.8 1.6 3.3 4.9 6 2.6 11.2-1.1 2.5-6.8 7-9.6 6.5-1.1-0.2-2.3-2.6-3.3-3.6-1.8-1.8-4.7-3.6-7.7-5.5-2-1.3-7.1-3.7-7.2-6-0.1-3.2 5.5-4.1 8.4-4.8 3.9-0.9 7.6-1.3 11.3-1.7q1.9 0 3.8 0c28.3 3 48.6 19.1 71.5 29.5 8.7 4 24 11.1 34.4 5.1 1.2-0.8 2.2-1.8 3.1-2.9z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "path671",
    className: "s3",
    d: "m318 306.7c-0.8-0.5-2.5-2-0.9-2.9-1.2 1.3 0.4 2.1 0.9 2.9z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "path673",
    className: "s3",
    d: "m75.2 297.6q1.3 1 2.4 2.4-1.4-1-2.4-2.4z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "path675",
    className: "s3",
    d: "m54 305c1 0.8 1.9 1.5 2.4 2.7-0.7-0.9-1.6-1.7-2.4-2.7z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "path677",
    className: "s3",
    d: "m53.8 319.2c0.7-0.9 1.6-1.7 2.4-2.6-0.5 1.1-1.5 1.8-2.4 2.6z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "path679",
    fillRule: "evenodd",
    className: "s7",
    d: "m47.1 319.2c-0.7-4.7-1.7-9-2.2-13.9 11.2-2.4 12.3 14.2 2.2 13.9z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "path699",
    className: "s3",
    d: "m147.2 344.4c-1.9-0.9-2.8-2.7-3.9-4.3 1.3 1.3 2.3 3 3.9 4.1q0 0.1 0 0.2z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "path701",
    className: "s2",
    d: "m262.4 341q-1.3 2.6-3.9 3.9c1.2-1.3 2.8-2.2 3.6-3.9q0.1 0 0.3 0z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "path703",
    className: "s3",
    d: "m141.2 335.3c-0.4-0.6-0.7-1.1-0.8-1.9 0.5 0.3 0.6 1.1 1 1.6-0.2 0-0.2 0.1-0.2 0.3z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "path759",
    className: "s1",
    d: "m55 506.2c7-0.6 12.4-2.7 17-5.6-1.3 4.2-3.6 9.4-5.5 13.7q-16.2 0-32.4 0c0.8-3.3 1.8-6.5 1.7-10.8 0.4-9.4 0.4-20.5 0-30 0.2-4.4-0.8-7.6-1.7-11 0-0.1 0-0.3-0.2-0.3 3.2-1.2 10.4 0.3 14.1 0-0.8 2.5-1.5 5.2-1.6 8.4-0.6 0.8-0.1 2.5-0.3 3.6-0.4 10.2-0.4 22 0 32.2 2.9-0.2 6.4 0.3 8.9-0.2z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "path773",
    fillRule: "evenodd",
    className: "s7",
    d: "m214.4 483.1c0.5-3.9 0-8.9 0.2-13.2q4 0 7.9 0c9.4 1.6 14.6 7.2 15.4 17.3q0 1.9 0 3.8c-0.2 10.8-6.2 15.6-17.1 15.6q-3.1 0-6.2 0c-0.2-2.1 0.3-4.9-0.2-6.7q0-8.4 0-16.8z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "path777",
    fillRule: "evenodd",
    className: "s7",
    d: "m116.4 501.6q-1.3 1.1-2.4 2.4c-10.6 8.3-26.6-1.6-25.6-15.4q0-1.6 0-3.3c-0.9-13.1 15.1-19.6 24.7-12q1 1.3 2.4 2.4c2.2 2.9 4 6.2 4.3 11q0 3.3 0 6.5c-0.3 3.7-1.7 6.1-3.4 8.4z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "path779",
    fillRule: "evenodd",
    className: "s7",
    d: "m302.4 486.5q0 3.5 0 6.9c-0.2 3.6-1.7 6-3.3 8.2q-1.4 1-2.4 2.4c-4.6 4.6-14.7 3.2-19-0.2-10.3-8.4-9.6-33.5 7.9-33.9 10-0.2 15.7 7.6 16.8 16.6z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "path785",
    className: "s4",
    d: "m127.5 80.6q1.7 0 3.3 0c-0.4 0.5-4.5 0.3-3.3 0z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "path787",
    className: "s2",
    d: "m54 97c0.6 1.4 0.1 3.9 0.3 5.7-0.6-1.4-0.1-3.9-0.3-5.7z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "path789",
    className: "s2",
    d: "m350 99.8c-0.2 1.3 0.3 3.2-0.3 4.1 0.2-1.3-0.3-3.2 0.3-4.1z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "path791",
    className: "s2",
    d: "m387.9 100.6q0 3 0 6c-0.4-1.5-0.4-4.6 0-6z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "path793",
    className: "s2",
    d: "m391.2 103.7c0.6 0.9 0.1 2.8 0.3 4.1-0.6-0.9-0.1-2.8-0.3-4.1z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "path797",
    className: "s2",
    d: "m94.1 110.4c0.5-0.4 3-0.5 3.1 0.2-0.7-0.3-2-0.2-3.1-0.2z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "path801",
    className: "s3",
    d: "m193 152.2c1.3 0.3 3.7 0.4 5 0-0.6 0.7-4.3 0.8-5 0z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "path803",
    className: "s4",
    d: "m144 206.2c0.1 1.9 0 3.8-0.2 5.5q-0.1 0-0.2 0c0.1-1.8 0.3-3.5 0.2-5.5q0.1 0 0.2 0z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "path805",
    className: "s3",
    d: "m260.4 206.2q0 2.7 0 5.5c-0.5-1.4 0-3.8-0.2-5.5q0.1 0 0.2 0z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "path807",
    className: "s2",
    d: "m17.6 211c0 1.1-0.1 2.3 0.2 3.1-0.8-0.2-0.6-2.6-0.2-3.1z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "path809",
    className: "s5",
    d: "m260.4 211.7q1 5.9 4.4 9.3 0 0.2 0 0.3c0.7 0.1 1 0.7 1.6 0.9q0 1.1 0 2.2c-0.1 0.9-0.1 1.9-0.4 2.6-17.7 0-36.7 0-53.6 0-0.4 16.1-0.2 34-0.2 51.6 0 5.3 0.4 13.4-0.5 17.1-3 0.5-6.3 4.3-9.6 4.3-1.7 0-3.8-1.6-5.5-2.4-1.9-0.9-3.7-1.6-5.3-2.6q0-34 0-68c-16.8-0.1-36.3 0.4-53.5-0.2 0.1-0.9-0.4-1.2-0.2-2.2 0-1.1-0.2-2.4 0.4-2.8 3.3-2 5-5.5 5.6-10.1q0.1 0 0.2 0c0.2-1.7 0.3-3.6 0.2-5.5 15.6-0.2 31.9 0.3 47.1-0.3 0.7-17.4-0.3-36.5 0.5-54q0.3 0.3 0.9 0.3 0.3 0 0.5 0c0.7 0.8 4.4 0.7 5 0 1-0.2 1.4-0.9 2.4-1 2.1-1.1 4.2-2.3 5.6-4.1 1.5 0.9 2.8 2 5.5 1.7 0.6-0.1 0.6 0.1 0.7 0.5 0.9 3.8 0 9.7 0 14.1 0 13.9 0 29 0 42.5 15.5 0.6 32.1 0.1 48 0.3 0.2 1.7-0.3 4.1 0.2 5.5z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "path811",
    className: "s2",
    d: "m266.9 222.2c0.4 0 0.7 0 0.7 0.3q-0.4 0-0.9 0c-0.2 0.6 0.3 1.7-0.3 1.9q0-1.1 0-2.2 0.3 0 0.5 0z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "path823",
    className: "s4",
    d: "m210.8 376.6c-0.2 10.4 0.3 21.6-0.3 31.6 0.2-10.4-0.3-21.6 0.3-31.6z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "path849",
    fillRule: "evenodd",
    className: "s7",
    d: "m307.5 284.4c1.6-0.2 3.1 0 4.1 0.5 3.3 1.6 5 9.1 0.9 12.2-3.5 2.6-9.8 0.4-10.5-4.5-0.8-5.1 1.8-7.8 5.5-8.2z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "path851",
    fillRule: "evenodd",
    className: "s7",
    d: "m69.9 311.8c-4.7 0.3-9.1-4.2-7.2-9.6 2.6-7.5 16.2-3.1 12.9 6.2-0.7 2-2.7 3.2-5.7 3.4z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "path855",
    fillRule: "evenodd",
    className: "s7",
    d: "m185.6 441.8q0-1.5 0-3.1c0.1-3.9 4.4-6.3 8.4-5 4.1 1.4 6.3 9.6 2.4 13.2-3.8 3.5-11.3 0.6-10.8-5.1z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "path857",
    className: "s2",
    d: "m217.5 44.4c-0.2 1.4 0.3 3.5-0.3 4.6q0-2.3 0-4.6 0.2 0 0.3 0z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "path859",
    className: "s2",
    d: "m110.9 53.3q3 0 6 0c-1.4 0.4-4.5 0.4-6 0z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "path865",
    className: "s2",
    d: "m349.7 84.7c0.6 1 0.1 3 0.3 4.3-0.6-0.9-0.1-2.9-0.3-4.3z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "path867",
    className: "s2",
    d: "m54.3 85.9c-0.2 1.9 0.3 4.5-0.3 6 0.2-1.9-0.3-4.5 0.3-6z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "path869",
    className: "s2",
    d: "m146.9 95q4.9 0 9.9 0c-2.8 0.4-7.2 0.4-9.9 0z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "path873",
    className: "s2",
    d: "m391.5 95.8c-0.2 1.2 0.3 3.2-0.3 4 0.2-1.2-0.3-3.2 0.3-4z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "path875",
    className: "s4",
    d: "m12.8 97.7c0.4 2.1 0.4 6 0 8.1q0-4 0-8.1z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "path877",
    className: "s2",
    d: "m133.7 100.3c1.5-0.4 4.7-0.4 6.3 0q-3.2 0-6.3 0z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "path887",
    className: "s4",
    d: "m25.5 117.6c0.5 1.3 0.1 3.6 0.2 5.3-0.5-1.3-0.1-3.6-0.2-5.3z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "path889",
    className: "s2",
    d: "m116.4 123.8q1.8 0 3.6 0c-0.6 0.4-2.9 0.4-3.6 0z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "path893",
    className: "s2",
    d: "m143.8 144.7c1.4-0.4 4.4-0.4 5.8 0q-2.9 0-5.8 0z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "path897",
    className: "s2",
    d: "m389.1 150.2c-0.2 3 0.3 6.6-0.3 9.2 0.2-3-0.3-6.6 0.3-9.2z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "path905",
    className: "s2",
    d: "m133.7 280.6c0.6 1.2 0.1 3.6 0.3 5.2-0.6-1.2-0.1-3.6-0.3-5.2z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "path921",
    className: "s2",
    d: "m170.9 377.3c0.4 10.7 0.4 23.1 0 33.8q0-16.9 0-33.8z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "path923",
    className: "s2",
    d: "m180.8 378q0 16.3 0 32.6c-0.4-10.3-0.4-22.3 0-32.6z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "path937",
    className: "s2",
    d: "m142.8 471.1c0.4 10.9 0.4 23.5 0 34.3q0-17.1 0-34.3z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "path939",
    className: "s2",
    d: "m185.8 471.1c-0.2 10.3 0.3 21.3-0.2 31.2 0.1-10.3-0.4-21.3 0.2-31.2z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "path941",
    className: "s2",
    d: "m360 472.1c0.4 8.4 0.4 18.5 0 26.9-0.3-0.4-0.7-0.8-0.9-1.2 0.5 0 0.5 0.6 0.9 0.7q0-13.2 0-26.4z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "path945",
    className: "s2",
    d: "m369.6 472.6q0 16.3 0 32.6c-0.4-10.3-0.4-22.3 0-32.6z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "path953",
    className: "s4",
    d: "m350 89c0.4 3.1 0.4 7.8 0 10.8q0-5.4 0-10.8z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "path955",
    className: "s4",
    d: "m185.6 111.1q0 1.9 0 3.9c-0.4-0.8-0.4-3.2 0-3.9z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "path963",
    className: "s4",
    d: "m220.1 375.6c-0.1 10.6 0.3 21.9-0.2 32.2 0.1-10.7-0.3-22 0.2-32.2z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "path969",
    className: "s4",
    d: "m326.9 473c0.4 9.6 0.4 20.9 0 30.5q0-15.2 0-30.5z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "path971",
    className: "s4",
    d: "m35.8 473.5c0.4 9.5 0.4 20.6 0 30q0-15 0-30z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "path973",
    className: "s4",
    d: "m46.1 474.2q0 16 0 32 0 0.1 0 0.2c-0.4-10.2-0.4-22 0-32.2z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "path985",
    className: "s2",
    d: "m131.1 223c0.7 0.2 1.6 0.2 2.6 0.2-0.4 0.5-2.2 0.3-2.6 0q0-0.1 0-0.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityOfLondonLogo);
export default __webpack_public_path__ + "static/media/City_of_London_logo.8925f589cef724fb758360e256029768.svg";
export { ForwardRef as ReactComponent };